(() => {
  'use strict';
  const catalog = {
  "forgehaus-m13-adapter": {
    "vehicles": [],
    "title": "M13 Adapter",
    "years": null
  },
  "forgehaus-26-wiper-blades": {
    "vehicles": [],
    "title": "26\" Wiper Blades",
    "years": null
  },
  "forgehaus-22-wiper-blades": {
    "vehicles": [],
    "title": "22\" Wiper Blades",
    "years": null
  },
  "forgehaus-20-wiper-blades": {
    "vehicles": [],
    "title": "20\" Wiper Blades",
    "years": null
  },
  "forgehaus-19-wiper-blades": {
    "vehicles": [],
    "title": "19\" Wiper Blades",
    "years": null
  },
  "forgehaus-17-wiper-blades": {
    "vehicles": [],
    "title": "17\" Wiper Blades",
    "years": null
  },
  "forgehaus-16-wiper-blades": {
    "vehicles": [],
    "title": "16\" Wiper Blades",
    "years": null
  },
  "forgehaus-18-wiper-blades": {
    "vehicles": [],
    "title": "18\" Wiper Blades",
    "years": null
  },
  "forgehaus-24-wiper-blades": {
    "vehicles": [],
    "title": "24\" Wiper Blades",
    "years": null
  },
  "forgehaus-m3-adapter": {
    "vehicles": [],
    "title": "M3 Adapter",
    "years": null
  },
  "forgehaus-xrs-375c4p-xrs\u2122-connect-4wd-pack": {
    "vehicles": [],
    "title": "XRS-375C4P XRS\u2122 Connect 4WD Pack",
    "years": null
  },
  "forgehaus-towkit-brake-controller": {
    "vehicles": [],
    "title": "SAVAGE ELECTRIC BRAKE CONTROLLER | UNIVERSAL 12V BRAKE CONTROLLER",
    "years": null
  },
  "forgehaus-tank-300-storage-box": {
    "vehicles": [],
    "title": "TANK 300 SIDE STORAGE BOX",
    "years": null
  },
  "forgehaus-tank-300-phantom-platform-ladder": {
    "vehicles": [],
    "title": "TANK 300 PHANTOM SERIES DRIVERS SIDE PLATFORM LADDER",
    "years": null
  },
  "forgehaus-byd-shark-6-performance-12-pin-brake-controller-harness": {
    "vehicles": [],
    "title": "BYD SHARK 6 PERFORMANCE BRAKE CONTROLLER HARNESS | PLUG & PLAY | 12 PIN TRAILER ADAPTER",
    "years": null
  },
  "forgehaus-gwm-cannon-bonnet-protector-moulded": {
    "vehicles": [],
    "title": "GWM CANNON 2020-2024 BONNET PROTECTOR MOULDED",
    "years": [
      2020,
      2024
    ]
  },
  "forgehaus-gwm-tank-300-stainless-steel-3-valved-cat-back-exhaust": {
    "vehicles": [],
    "title": "GWM TANK 300 STAINLESS STEEL 3\" VALVED CAT BACK EXHAUST",
    "years": null
  },
  "forgehaus-savage-electric-smartsteps-side-steps-with-rgb-step-lighting-denza-b5-2026": {
    "vehicles": [
      "denza-b5"
    ],
    "title": "SAVAGE ELECTRIC SMARTSTEPS SIDE STEPS WITH RGB STEP LIGHTING DENZA B5 2026+",
    "years": [
      2026,
      2099
    ]
  },
  "forgehaus-savage-hard-lid-gwm-alpha-2024": {
    "vehicles": [],
    "title": "SAVAGE CARRY HARD LID GWM ALPHA 2024+",
    "years": [
      2024,
      2099
    ]
  },
  "forgehaus-gwm-tank-500-armour-forged-bullbar-hoopless": {
    "vehicles": [],
    "title": "GWM TANK 500 ARMOUR FORGED HOOPLESS BULL BAR",
    "years": null
  },
  "forgehaus-tank-300-armour-hooped-bull-bar-all-models": {
    "vehicles": [],
    "title": "TANK 300 ARMOUR (HOOPED) BULL BAR ALL MODELS",
    "years": null
  },
  "forgehaus-tank-300-rock-sliders": {
    "vehicles": [],
    "title": "TANK 300 SIDE STEPS",
    "years": null
  },
  "forgehaus-phantom-series-quick-release-awning-brackets": {
    "vehicles": [],
    "title": "PHANTOM SERIES QUICK RELEASE AWNING BRACKETS",
    "years": null
  },
  "forgehaus-savage-full-armour-under-body-protection-kit-denza-b5-2026": {
    "vehicles": [
      "denza-b5"
    ],
    "title": "SAVAGE FULL ARMOUR ALUMINIUM UNDER BODY BASH PLATE PROTECTION KIT DENZA B5 2026+",
    "years": [
      2026,
      2099
    ]
  },
  "forgehaus-savage-full-armour-under-body-protection-kit-denza-b8-2026": {
    "vehicles": [
      "denza-b8"
    ],
    "title": "SAVAGE FULL ARMOUR ALUMINIUM UNDER BODY BASH PLATE PROTECTION KIT DENZA B8 2026+",
    "years": [
      2026,
      2099
    ]
  },
  "forgehaus-savage-electric-smartsteps-side-steps-with-rgb-step-lighting-denza-b8-2026": {
    "vehicles": [
      "denza-b8"
    ],
    "title": "SAVAGE ELECTRIC SMARTSTEPS SIDE STEPS WITH RGB STEP LIGHTING DENZA B8 2026+",
    "years": [
      2026,
      2099
    ]
  },
  "forgehaus-tank-300-savage-full-length-platform-with-led-32-lightbar": {
    "vehicles": [],
    "title": "TANK 300 SAVAGE FULL LENGTH PLATFORM (WITH LED 32\" LIGHTBAR)",
    "years": null
  },
  "forgehaus-gwm-alpha-grill-insect-mesh": {
    "vehicles": [],
    "title": "GWM ALPHA GRILLE INSECT MESH",
    "years": null
  },
  "forgehaus-bonnet-nose-blackout-cover-gwm-alpha-tank-500": {
    "vehicles": [],
    "title": "BONNET NOSE BLACKOUT COVER GWM ALPHA & TANK 500",
    "years": null
  },
  "forgehaus-gwm-tank-300-500-savage-key-case-cover-black": {
    "vehicles": [],
    "title": "GWM TANK 300 & 500 SAVAGE KEY CASE/COVER BLACK",
    "years": null
  },
  "forgehaus-tank-300-retractable-trunk-cover": {
    "vehicles": [],
    "title": "TANK 300 Retractable trunk cover",
    "years": null
  },
  "forgehaus-gwm-cannon-the-beast-hoopless-bull-bar-2025": {
    "vehicles": [
      "gwm-cannon"
    ],
    "title": "GWM CANNON \"THE BEAST\" HOOPLESS BULL BAR 2025+ FACELIFT",
    "years": [
      2025,
      2099
    ]
  },
  "forgehaus-gwm-alpha-forged-rampage-hooped-bullbar": {
    "vehicles": [],
    "title": "SAVAGE FORGED RAMPAGE HOOPED BULL BAR - GWM ALPHA 2024+ DIESEL, HEV & PHEV",
    "years": [
      2024,
      2099
    ]
  },
  "forgehaus-tank-300-savage-high-beam-trigger-harness-and-piggy-backs": {
    "vehicles": [],
    "title": "TANK 300 SAVAGE HIGH BEAM TRIGGER HARNESS AND 2 PIGGY-BACKS",
    "years": null
  },
  "forgehaus-suede-key-case-denza-b5-b8-2026": {
    "vehicles": [],
    "title": "ALCANTARA KEY CASE DENZA B5 & B8 2026+",
    "years": [
      2026,
      2099
    ]
  },
  "forgehaus-soft-close-boot-actuator-gwm-tank-300": {
    "vehicles": [],
    "title": "SOFT CLOSE BOOT ACTUATOR - GWM TANK 300",
    "years": null
  },
  "forgehaus-savage-phantom-series-roof-platform-gwm-alpha-2024-all-models-v3-update": {
    "vehicles": [],
    "title": "SAVAGE PHANTOM SERIES ROOF PLATFORM - GWM ALPHA 2024+ ALL MODELS (V3 UPDATE)",
    "years": [
      2024,
      2099
    ]
  },
  "forgehaus-gwm-cannon-alpha-savage-apex-lift-kit": {
    "vehicles": [
      "gwm-cannon-alpha"
    ],
    "title": "GWM SAVAGE APEX 2-2.5\" SUSPENSION LIFT KIT GWM ALPHA 2.4 DEISEL & HEV",
    "years": null
  },
  "forgehaus-haval-h7-towbar": {
    "vehicles": [],
    "title": "HAVAL H7 TOWBAR",
    "years": null
  },
  "forgehaus-savage-drift-cart-brake-cable": {
    "vehicles": [],
    "title": "SAVAGE DRIFT CART BRAKE CABLE",
    "years": null
  },
  "forgehaus-jaecoo-j7-2025-boot-mat": {
    "vehicles": [],
    "title": "JAECOO J7 1.6 PETROL 2025+ BOOT 3D MOULDED MAT",
    "years": [
      2025,
      2099
    ]
  },
  "forgehaus-gwm-tank-300-led-foglights-yellow-light": {
    "vehicles": [],
    "title": "TANK 300 SAVAGE LED FOGLIGHTS (YELLOW) (OFF ROAD USE ONLY)",
    "years": null
  },
  "forgehaus-2x-50a-anderson-plugs-with-flush-mount-covers": {
    "vehicles": [],
    "title": "2x 50A ANDERSON PLUGS WITH FLUSH MOUNT & COVERS",
    "years": null
  },
  "forgehaus-bestwyll-premium-tub-rack": {
    "vehicles": [],
    "title": "BESTWYLL PREMIUM TUB RACK",
    "years": null
  },
  "forgehaus-gwm-alpha-awning-bracket": {
    "vehicles": [],
    "title": "GWM ALPHA AWNING BRACKET (pair)",
    "years": null
  },
  "forgehaus-landcruiser-lc300-floor-mat-set": {
    "vehicles": [],
    "title": "TOYOTA LANDCRUISER LC300 3D MOULDED FLOOR MATS FOR LAND CRUISER",
    "years": null
  },
  "forgehaus-gwm-cannon-savage-sliding-trifold-tub-cover": {
    "vehicles": [
      "gwm-cannon"
    ],
    "title": "SAVAGE GLIDELOCK TRIFOLD  HARD LID COVER \u2013 GWM CANNON 2020+ TONNEAU",
    "years": [
      2020,
      2099
    ]
  },
  "forgehaus-savage-reverb-pro-gwm-alpha-diesel": {
    "vehicles": [],
    "title": "SAVAGE REVERB PRO GWM ALPHA DIESEL/HEV 2-2.5\" SUSPENSION LIFT KIT",
    "years": null
  },
  "forgehaus-tank-500-led-foglights": {
    "vehicles": [],
    "title": "TANK 500 SAVAGE LED FOGLIGHTS (YELLOW) (OFF ROAD USE ONLY)",
    "years": null
  },
  "forgehaus-gwm-tank-300-under-grille-trims-pair": {
    "vehicles": [],
    "title": "GWM TANK 300 UNDER GRILLE TRIMS (PAIR)",
    "years": null
  },
  "forgehaus-gwm-alpha-2024-tail-light-piggy-back-harness": {
    "vehicles": [],
    "title": "GWM ALPHA 2024+ TAIL LIGHT PIGGY-BACK HARNESS",
    "years": [
      2024,
      2099
    ]
  },
  "forgehaus-mg-u9-dashmat": {
    "vehicles": [],
    "title": "MG U9 / LDV TERRON 9 DASHMAT",
    "years": null
  },
  "forgehaus-tank-300-1-5-lift-spacer-kit": {
    "vehicles": [],
    "title": "TANK 300 1.5\" LIFT SPACER KIT",
    "years": null
  },
  "forgehaus-tank-500-reverb-pro-suspension-lift-kit": {
    "vehicles": [],
    "title": "SAVAGE REVERB PRO 2\" SUSPENSION LIFT KIT FOR GWM ALPHA PHEV Hi4T",
    "years": null
  },
  "forgehaus-ddpai-z60-pro-4g-hardwire-package": {
    "vehicles": [],
    "title": "DDPAI Z60 PRO 4G ULTIMATE DASH CAM PACKAGE",
    "years": null
  },
  "forgehaus-ddpai-hardwire-kit": {
    "vehicles": [],
    "title": "DDPAI HARDWIRE KIT",
    "years": null
  },
  "forgehaus-ddpai-4g-cloud-box-for-z60-z60-pro": {
    "vehicles": [],
    "title": "DDPAI 4G CLOUD BOX FOR Z60 & Z60 PRO",
    "years": null
  },
  "forgehaus-ddpai-z60-pro-dashcam-front-4k-1080p-rear-camera": {
    "vehicles": [],
    "title": "DDPAI Z60 PRO DASHCAM FRONT 4K + 1080P REAR CAMERA",
    "years": null
  },
  "forgehaus-tank-300-ironclad-grille": {
    "vehicles": [],
    "title": "TANK 300 IRONCLAD GRILLE",
    "years": null
  },
  "forgehaus-savage-command-overhead-switch-system-suits-gwm-alpha": {
    "vehicles": [],
    "title": "SAVAGE COMMAND OVERHEAD SWITCH SYSTEM - SUITS GWM ALPHA",
    "years": null
  },
  "forgehaus-3-in-1-dlush-mount-10a-12v-socket-50a-anderson-socket-usb-a": {
    "vehicles": [],
    "title": "3-in-1 FLUSH MOUNT - 10A 12V SOCKET, 50A ANDERSON SOCKET, USB A",
    "years": null
  },
  "forgehaus-phantom-platform-tie-down-eyelets-4-pack": {
    "vehicles": [],
    "title": "PHANTOM SERIES PLATFORM TIE DOWN EYELETS (4 PACK)",
    "years": null
  },
  "forgehaus-phantom-platform-s-steel-hardware-kit-m6x40-10pce": {
    "vehicles": [],
    "title": "PHANTOM SERIES PLATFORM S/STEEL HARDWARE KIT",
    "years": null
  },
  "forgehaus-phantom-platform-slide-nuts-square-15pce": {
    "vehicles": [],
    "title": "PHANTOM SERIES PLATFORM SLIDE NUTS (SQUARE) 15PCE",
    "years": null
  },
  "forgehaus-phantom-platform-slide-nuts-15pce": {
    "vehicles": [],
    "title": "PHANTOM SERIES PLATFORM SLIDE NUTS M6 (RECTANGLE) 15PCE",
    "years": null
  },
  "forgehaus-savage-reverb-pro-rear-drop-links-gwm-tank-300": {
    "vehicles": [],
    "title": "SAVAGE REVERB PRO REAR DROP LINKS GWM TANK 300",
    "years": null
  },
  "forgehaus-tank-300-awning-bracket": {
    "vehicles": [],
    "title": "TANK 300 AWNING BRACKETS (PAIR)",
    "years": null
  },
  "forgehaus-gwm-alpha-phev-towbar": {
    "vehicles": [],
    "title": "GWM ALPHA PHEV TOW BAR",
    "years": null
  },
  "forgehaus-tank-500-alpha-magnetic-phone-uhf-holder": {
    "vehicles": [],
    "title": "TANK 500 / ALPHA MAGNETIC PHONE/UHF HOLDER PACKAGE",
    "years": null
  },
  "forgehaus-savage-premium-rear-boot-storage-box-suit-denza-b5-gwm-tank-500": {
    "vehicles": [],
    "title": "SAVAGE PREMIUM REAR BOOT STORAGE BOX SUIT DENZA B5 & GWM TANK 500",
    "years": null
  },
  "forgehaus-hik-digital-reverse-camera-system-replacment-mirror-style": {
    "vehicles": [],
    "title": "HIKVISION M1 SMART REAR VIEW MIRROR \u2013 EXTERNAL REVERSE CAMERA",
    "years": null
  },
  "forgehaus-gwm-alpha-shadepro-rear-sunshade-pair-all-models": {
    "vehicles": [],
    "title": "GWM ALPHA SHADEPRO REAR SUNS HADE PAIR ALL MODELS",
    "years": null
  },
  "forgehaus-gwm-alpha-split-tailgate-lip-protector": {
    "vehicles": [],
    "title": "GWM ALPHA SPLIT TAILGATE LIP PROTECTOR",
    "years": null
  },
  "forgehaus-tank-300-savage-full-length-platform-premium-range": {
    "vehicles": [],
    "title": "GWM TANK 300 SAVAGE FULL LENGTH PLATFORM (PREMIUM RANGE)",
    "years": null
  },
  "forgehaus-byd-sealion-6-dashmat": {
    "vehicles": [],
    "title": "BYD SEALION 6 DASHMAT",
    "years": null
  },
  "forgehaus-tank-500-grille-with-motion-light-package": {
    "vehicles": [],
    "title": "TANK 500 OBSIDIAN PULSE GRILL + \"TANK\" NOSE PEICE KIT",
    "years": null
  },
  "forgehaus-jaecoo-j7-savage-3d-moulded-floor-mats": {
    "vehicles": [],
    "title": "JAECOO J7 SAVAGE 3D MOULDED FLOOR MATS (not suitable for phev model)",
    "years": null
  },
  "forgehaus-tank-300-phantom-platform": {
    "vehicles": [],
    "title": "SAVAGE PHANTOM SERIES ROOF PLATFORM - GWM TANK 300 ALL MODELS",
    "years": null
  },
  "forgehaus-byd-shark-6-predator-flares": {
    "vehicles": [
      "byd-shark-6"
    ],
    "title": "BYD Shark 6 Fender Flares Savage Predator 30 mm Widebody Kit",
    "years": null
  },
  "forgehaus-gwm-alpha-premium-tinted-weathershields": {
    "vehicles": [],
    "title": "GWM ALPHA PREMIUM TINTED WEATHERSHIELDS",
    "years": null
  },
  "forgehaus-tank-300-savage-electric-smartsteps-with-rgb-step-lighting": {
    "vehicles": [],
    "title": "SAVAGE ELECTRIC SMARTSTEPS SIDE STEPS WITH RGB STEP LIGHTING GWM TANK 300 2023+",
    "years": [
      2023,
      2099
    ]
  },
  "forgehaus-savage-folding-uhf-antenna-bracket": {
    "vehicles": [],
    "title": "SAVAGE FOLDING UHF ANTENNA BRACKET",
    "years": null
  },
  "forgehaus-savage-drift-kart-36v-500w": {
    "vehicles": [],
    "title": "SAVAGE DRIFT KART 36V 500W",
    "years": null
  },
  "forgehaus-tank-300-rear-tailgate-table": {
    "vehicles": [],
    "title": "SAVAGE CNC ALLOY TAILGATE TABLE GWM TANK 300",
    "years": null
  },
  "forgehaus-byd-sealion-6-weathershields": {
    "vehicles": [],
    "title": "BYD SEALION 6 WEATHERSHIELDS",
    "years": null
  },
  "forgehaus-2025-vanta-xsr-fitting-kit": {
    "vehicles": [],
    "title": "2025+ VANTA / XSR FITTING KIT",
    "years": [
      2025,
      2099
    ]
  },
  "forgehaus-phantom-platform-hidden-wire-brackets": {
    "vehicles": [],
    "title": "HIDDEN CABLE MANAGEMENT KIT \u2013 SUITS ALL PHANTOM SERIES PLATFORMS",
    "years": null
  },
  "forgehaus-savage-tyre-carrier-rack": {
    "vehicles": [],
    "title": "SAVAGE ROGUE TYRE/WHEEL CARRIER RACK WITH STORAGE PLATFORM",
    "years": null
  },
  "forgehaus-gwm-tank-300-shadepro-rear-sunshade-pair": {
    "vehicles": [],
    "title": "GWM TANK 300 SHADEPRO REAR SUN SHADE PAIR",
    "years": null
  },
  "forgehaus-gwm-alpha-hi4t-phev-tub-mat": {
    "vehicles": [],
    "title": "GWM ALPHA TUB MAT (FOR PHEV Hi4-T MODEL)",
    "years": null
  },
  "forgehaus-universal-adjustable-roof-cross-bars-fits-gwm-cannon-2020": {
    "vehicles": [
      "gwm-cannon"
    ],
    "title": "UNIVERSAL ADJUSTABLE ROOF CROSS BARS \u2013 FITS GWM CANNON 2020+",
    "years": [
      2020,
      2099
    ]
  },
  "forgehaus-savage-switchbeam-9-led-driving-lights-pair": {
    "vehicles": [],
    "title": "SAVAGE SWITCHBEAM 9\" LED SPOT LIGHT DRIVING LIGHTS (PAIR)",
    "years": null
  },
  "forgehaus-savage-10-preditor": {
    "vehicles": [],
    "title": "SAVAGE 10\" PREDATOR LED SPOT LIGHT DRIVING LIGHTS (PAIR)",
    "years": null
  },
  "forgehaus-gwm-cannon-2020-2025-savage-offroad-reverb-pro-suspension-lift-kit": {
    "vehicles": [
      "gwm-cannon"
    ],
    "title": "GWM CANNON 2020-2025+ SAVAGE OFFROAD 2\" REVERB PRO SUSPENSION LIFT KIT",
    "years": [
      2020,
      2025
    ]
  },
  "forgehaus-tank-500-universal-ball-mount-phone-uhf": {
    "vehicles": [],
    "title": "TANK 500 / ALPHA UNIVERSAL BALL MOUNT - PHONE/UHF",
    "years": null
  },
  "forgehaus-tank-300-reverb-1-5-2-adjustable-lift-kit": {
    "vehicles": [],
    "title": "TANK 300 REVERB 1.5\" SUSPENSION LIFT KIT",
    "years": null
  },
  "forgehaus-tank-300-reverb-pro-suspension-lift-kit": {
    "vehicles": [],
    "title": "TANK 300 SAVAGE TECH REVERB PRO 2\" SUSPENSION LIFT KIT",
    "years": null
  },
  "forgehaus-tank-300-armour-rear-bar-with-tyre-carrier": {
    "vehicles": [],
    "title": "TANK 300 ARMOUR REAR BAR WITH TYRE CARRIER",
    "years": null
  },
  "forgehaus-tank-300-drop-links": {
    "vehicles": [],
    "title": "Tank 300/500 adjustable drop links.",
    "years": null
  },
  "forgehaus-savage-omega-suspension-gwm-alpha-phev": {
    "vehicles": [],
    "title": "SAVAGE OMEGA SUSPENSION GWM ALPHA PHEV Hi4T LIFT KIT",
    "years": null
  },
  "forgehaus-savage-snorkel-petrol": {
    "vehicles": [],
    "title": "SAVAGE TANK 300 TRAIL MASTER SNORKEL KIT PETROL & DIESEL OEM FITMENT",
    "years": null
  },
  "forgehaus-tank-300-downpipe": {
    "vehicles": [],
    "title": "TANK 300 (2.0T) PETROL HIGH-FLOW HEAT-SHIELDED DOWNPIPE",
    "years": null
  },
  "forgehaus-gwm-tank-300-petrol-85l-auxilary-fuel-tank": {
    "vehicles": [],
    "title": "GWM TANK 300 PETROL 85L AUXILARY FUEL TANK",
    "years": null
  },
  "forgehaus-gwm-cannon-deep-floor-mats-full-sets": {
    "vehicles": [],
    "title": "GWM Cannon 3D Moulded Heavy Duty All Weather Floor Mats | Full Set (NOT ALPHA)",
    "years": null
  },
  "forgehaus-tank-500-monotube-nitrogen-suspension": {
    "vehicles": [],
    "title": "TANK 500 MONOTUBE NITROGEN SUSPENSION (HEV Only)",
    "years": null
  },
  "forgehaus-tank-300-6-wireless-switch-with-dash-mounted-accesories-panel": {
    "vehicles": [],
    "title": "TANK 300 SAVAGE COMMAND CENTRE WITH 6 SWITCH WIRELESS CONTROLLER",
    "years": null
  },
  "forgehaus-tank-300-phantom-platform-package": {
    "vehicles": [],
    "title": "SAVAGE PHANTOM SERIES ROOF PLATFORM PACKAGE INCLUDES ACC PANEL & LADDER - GWM TANK 300 ALL MODELS",
    "years": null
  },
  "forgehaus-tank-500-savage-piggy-back": {
    "vehicles": [],
    "title": "TANK 500 SAVAGE PIGGY-BACK",
    "years": null
  },
  "forgehaus-savage-positive-trigger-harness": {
    "vehicles": [],
    "title": "SAVAGE POSITIVE TRIGGER HARNESS",
    "years": null
  },
  "forgehaus-gwm-alpha-uhf-antenna-bracket-bonnet-mount": {
    "vehicles": [],
    "title": "GWM ALPHA / GWM TANK 500 UHF ANTENNA BRACKET BONNET MOUNT",
    "years": null
  },
  "forgehaus-tank-300-rear-torsion-bars": {
    "vehicles": [],
    "title": "TANK 300 ADJUSTABLE TRAILING ARMS & DROP LINKS",
    "years": null
  },
  "forgehaus-wetseat-neoprene-seat-covers-for-gwm-tank-500-front-middle-rows-australian-made": {
    "vehicles": [],
    "title": "GWM ALPHA Wetseat Neoprene Seat Covers  \u2013 Front & Middle Row (Australian Made)",
    "years": null
  },
  "forgehaus-y-adaptor-for-spotlights": {
    "vehicles": [],
    "title": "2-PIN DEUTSCH SPLITTER FOR SPOT LIGHTS & WORK LIGHTS Y ADAPTOR",
    "years": null
  },
  "forgehaus-toyota-lc300-bonnet-protector": {
    "vehicles": [],
    "title": "TOYOTA LC300 BONNET PROTECTOR",
    "years": null
  },
  "forgehaus-gwm-alpha-tank-500-dashboard-storage-tray-organizer": {
    "vehicles": [],
    "title": "GWM ALPHA / TANK 500 DASHBOARD STORAGE TRAY ORGANIZER",
    "years": null
  },
  "forgehaus-tank-500-wet-seat-seatcovers-front-rear": {
    "vehicles": [],
    "title": "GWM Tank 500 Wetseat Neoprene Seat Covers \u2013 Front & Middle Rows (Australian Made)",
    "years": null
  },
  "forgehaus-tank-300-wet-seat-seatcovers-front-rear": {
    "vehicles": [],
    "title": "Wetseat Neoprene Seat Covers for GWM Tank 300 \u2013 Full Set Front & Rear (Australian Made)",
    "years": null
  },
  "forgehaus-test-mech": {
    "vehicles": [],
    "title": "Test Mech",
    "years": null
  },
  "forgehaus-gwm-cannon-molle-panel-lhs": {
    "vehicles": [
      "gwm-cannon"
    ],
    "title": "SAVAGE TECH MOLLE SIDE STORAGE FOR GWM CANNON",
    "years": null
  },
  "forgehaus-tank-500-grill-4": {
    "vehicles": [],
    "title": "TANK 500 GRILLE #3",
    "years": null
  },
  "forgehaus-savage-phantom-platform-awning-brackets": {
    "vehicles": [],
    "title": "SAVAGE PHANTOM SERIES PLATFORM 270 AWNING BRACKETS 3 PACK",
    "years": null
  },
  "forgehaus-gwm-alpha-tank-500-dashmat": {
    "vehicles": [],
    "title": "GWM ALPHA 2024+ / TANK 500 2024+ DASHMAT",
    "years": [
      2024,
      2099
    ]
  },
  "forgehaus-tank-300-savage-towkit-tow-bar-harness-plug-and-play-not-compatible-with-hybrid-hev-or-diesel-copy": {
    "vehicles": [],
    "title": "TANK 300 DIESEL SAVAGE TOWKIT TOW BAR HARNESS PLUG AND PLAY",
    "years": null
  },
  "forgehaus-savage-hardshell-rooftop-tent": {
    "vehicles": [],
    "title": "SAVAGE HARDSHELL ROOFTOP TENT",
    "years": null
  },
  "forgehaus-tank-500-sports-grille-4": {
    "vehicles": [],
    "title": "TANK 500 SPORTS GRILLE #4 BUNDLE",
    "years": null
  },
  "forgehaus-tank-500-grille-4": {
    "vehicles": [],
    "title": "TANK 500 SPORTS GRILLE #4",
    "years": null
  },
  "forgehaus-tank-500-electronic-nitrogen-lift-kit": {
    "vehicles": [],
    "title": "TANK 500 ELECTRONIC NITROGEN LIFT KIT",
    "years": null
  },
  "forgehaus-qld-mod-plate-long-range-auxiliary-fuel-tank": {
    "vehicles": [],
    "title": "QLD MOD PLATE \u2013 LONG RANGE / AUXILIARY FUEL TANK",
    "years": null
  },
  "forgehaus-tank-300-nitrogen-monotube-suspension-kit": {
    "vehicles": [],
    "title": "TANK 300 NITROGEN MONOTUBE SUSPENSION KIT",
    "years": null
  },
  "forgehaus-gwm-alpha-tub-mat": {
    "vehicles": [],
    "title": "TUB MAT - GWM ALPHA (DIESEL AND HEV)",
    "years": null
  },
  "forgehaus-fuel-rincon-wheels": {
    "vehicles": [],
    "title": "FUEL FC857 RINCON WHEELS",
    "years": null
  },
  "forgehaus-wet-n-wild-neoprene-seatcovers": {
    "vehicles": [],
    "title": "WET 'N' WILD NEOPRENE SEATCOVERS",
    "years": null
  },
  "forgehaus-tank-300-diesel-reverb-1-5-2-lift-kit": {
    "vehicles": [],
    "title": "TANK 300 DIESEL REVERB 1.5-2\" LIFT KIT",
    "years": null
  },
  "forgehaus-tank-300-a-pillar-mount-with-brackets": {
    "vehicles": [],
    "title": "TANK 300 A-PILLAR MOUNT WITH BRACKETS PAIR",
    "years": null
  },
  "forgehaus-gwm-alpha-genuine-taillight-replacement": {
    "vehicles": [],
    "title": "GWM Alpha Tail lights \u2013 Premium Metallic Upgrade PAIR",
    "years": null
  },
  "forgehaus-tank-300-phone-mount-bracket": {
    "vehicles": [],
    "title": "TANK 300 PHONE MOUNT BRACKET",
    "years": null
  },
  "forgehaus-supcelion-100ah-50a-dc-dc-lithuim-battery-package": {
    "vehicles": [],
    "title": "SUPCELION 100AH + 50A DC-DC LITHUIM BATTERY PACKAGE",
    "years": null
  },
  "forgehaus-fortress-tub-rack-basket-inserts": {
    "vehicles": [],
    "title": "FORTRESS TUB RACK BASKET INSERTS PAIR",
    "years": null
  },
  "forgehaus-gwm-tank-500-air-suspension-helper-kit": {
    "vehicles": [],
    "title": "GWM TANK 500 & GWM ALPHA PHEV AIR SUSPENSION HELPER KIT",
    "years": null
  },
  "forgehaus-universal-roller-cover-cross-bars-copy": {
    "vehicles": [],
    "title": "PREMIUM SAVAGE UNIVERSAL ROLLER SHUTTER CROSS BARS (PAIR)",
    "years": null
  },
  "forgehaus-roh-assault": {
    "vehicles": [],
    "title": "ROH ASSAULT",
    "years": null
  },
  "forgehaus-18x9-12-warrior-satin-black": {
    "vehicles": [],
    "title": "KINGS WARRIOR WHEELS",
    "years": null
  },
  "forgehaus-kmc-grs-wheel": {
    "vehicles": [],
    "title": "KMC GRS WHEEL",
    "years": null
  },
  "forgehaus-tank-300-manta-steel-performance-exhaust": {
    "vehicles": [],
    "title": "TANK 300 MANTA STEEL PERFORMANCE EXHAUST",
    "years": null
  },
  "forgehaus-kmc-km552-wheel": {
    "vehicles": [],
    "title": "KMC IMS WHEEL",
    "years": null
  },
  "forgehaus-gwm-alpha-piggy-back": {
    "vehicles": [],
    "title": "GWM ALPHA PIGGY BACK",
    "years": null
  },
  "forgehaus-gwm-tank-300-slimline-rackless-rooftop-tent-with-ladder": {
    "vehicles": [],
    "title": "GWM TANK 300 SLIMLINE RACKLESS ROOFTOP TENT WITH LADDER",
    "years": null
  },
  "forgehaus-renogy-12v-50a-dual-input-dc-to-dc-battery-charger-with-mppt": {
    "vehicles": [],
    "title": "RENOGY 12V 50A DUAL INPUT DC TO DC BATTERY CHARGER WITH MPPT",
    "years": null
  },
  "forgehaus-hardkorr-dc-control-box": {
    "vehicles": [],
    "title": "HARDKORR DC CONTROL BOX",
    "years": null
  },
  "forgehaus-supcelion-12-8v-lifep04-100ah-slimline-lithium-battery": {
    "vehicles": [],
    "title": "SUPCELION 12.8V LiFeP04 100Ah SLIMLINE LITHIUM BATTERY",
    "years": null
  },
  "forgehaus-gme-ae4018bk1-970mm-elevated-feed-antenna-6-6dbi-gain": {
    "vehicles": [],
    "title": "GME AE4018BK1 - 970mm Elevated-Feed Antenna (6.6dBi Gain)",
    "years": null
  },
  "forgehaus-predator-mutant-x-mt": {
    "vehicles": [],
    "title": "PREDATOR MUTANT X-MT",
    "years": null
  },
  "forgehaus-predator-x-at": {
    "vehicles": [],
    "title": "PREDATOR MUTANT X-AT",
    "years": null
  },
  "forgehaus-tank-300-manta-performance-exhaust": {
    "vehicles": [],
    "title": "TANK 300 MANTA STAINLESS STEEL PERFORMANCE EXHAUST",
    "years": null
  },
  "forgehaus-byd-shark-flat-pack-alloy-aluminium-canopy-with-central-locking": {
    "vehicles": [
      "byd-shark-6"
    ],
    "title": "BYD SHARK 6 FLAT PACK ALLOY/ ALUMINIUM CANOPY WITH CENTRAL LOCKING",
    "years": null
  },
  "forgehaus-tank-300-reverse-light-trigger-harness": {
    "vehicles": [],
    "title": "TANK 300 REVERSE LIGHT TRIGGER HARNESS",
    "years": null
  },
  "forgehaus-byd-shark-3d-moulded-floor-mats-still-protection": {
    "vehicles": [],
    "title": "BYD SHARK 6 PREMIUM & PERFORMANCE SAVAGE 3D MOULDED TPE FLOOR MATS & DOOR SILL PROTECTION",
    "years": null
  },
  "forgehaus-awning-brackets-for-fortress-tub-racks": {
    "vehicles": [],
    "title": "AWNING BRACKETS FOR FORTRESS TUB RACKS",
    "years": null
  },
  "forgehaus-renogy-12v-dc-dc-charger": {
    "vehicles": [],
    "title": "RENOGY 12V 40A DC-DC CHARGER",
    "years": null
  },
  "forgehaus-supcelion-12-8v-lifep04-120ah-slimline-lithium-battery": {
    "vehicles": [],
    "title": "SUPCELION 12.8V LiFeP04 120Ah SLIMLINE LITHIUM BATTERY",
    "years": null
  },
  "forgehaus-falken-wildpeak-at3-285-65r18": {
    "vehicles": [],
    "title": "FALKEN WILDPEAK AT3 - 285/65R18 (EACH)",
    "years": null
  },
  "forgehaus-carbon-offroad-12k-winch": {
    "vehicles": [],
    "title": "CARBON OFFROAD 12K WINCH",
    "years": null
  },
  "forgehaus-9-savage-spot-lights": {
    "vehicles": [],
    "title": "9\" LED SAVAGE BLAZE SPOT LIGHT DRIVING LIGHTS (PAIR)",
    "years": null
  },
  "forgehaus-savage-tech-molypanel-side-storage": {
    "vehicles": [],
    "title": "SAVAGE TECH MOLLE SIDE STORAGE FOR GWM ALPHA",
    "years": null
  },
  "forgehaus-kings-deceit-wheel-satin-black-each": {
    "vehicles": [],
    "title": "KINGS DECEIT WHEEL SATIN BLACK EACH",
    "years": null
  },
  "forgehaus-tank-500-recovery-points-1": {
    "vehicles": [],
    "title": "TANK 500 & GWM ALPHA RECOVERY POINTS",
    "years": null
  },
  "forgehaus-platform-light-with-bracket-pair": {
    "vehicles": [],
    "title": "PHANTOM SERIES PLATFROM GRAB HANDLES (PAIR)",
    "years": null
  },
  "forgehaus-savage-22-led-light-bar-copy": {
    "vehicles": [],
    "title": "SAVAGE 40\" LED LIGHT BAR",
    "years": null
  },
  "forgehaus-gwm-tank-300-upgraded-drive-shaft": {
    "vehicles": [],
    "title": "GWM TANK 300 UPGRADED DRIVE SHAFT PETROL MODEL",
    "years": null
  },
  "forgehaus-savage-off-road-fitted-caps": {
    "vehicles": [],
    "title": "SAVAGE OFF-ROAD FITTED CAPS",
    "years": null
  },
  "forgehaus-digital-dsp-amplifier-for-gwm-cannon": {
    "vehicles": [],
    "title": "SAVAGE DSP AMPLIFER",
    "years": null
  },
  "forgehaus-gwm-alpha-weathershields": {
    "vehicles": [],
    "title": "GWM ALPHA TINTED WEATHERSHIELDS",
    "years": null
  },
  "forgehaus-diff-breather-kit": {
    "vehicles": [],
    "title": "DIFF BREATHER KIT",
    "years": null
  },
  "forgehaus-bottle-opener-for-platform": {
    "vehicles": [],
    "title": "PHANTOM SERIES PLATFORM BOTTLE OPENER",
    "years": null
  },
  "forgehaus-kicker-cs-6-5-component-speakers": {
    "vehicles": [],
    "title": "KICKER CS 6.5\" COMPONENT SPEAKERS",
    "years": null
  },
  "forgehaus-kicker-cs-6-5-coaxial-speakers": {
    "vehicles": [],
    "title": "KICKER CS 6.5\" COAXIAL SPEAKERS",
    "years": null
  },
  "forgehaus-tank-300-smart-key-fob": {
    "vehicles": [],
    "title": "TANK 300 SMART KEY FOB",
    "years": null
  },
  "forgehaus-byd-puddle-lights": {
    "vehicles": [],
    "title": "BYD PUDDLE DOOR LIGHTS",
    "years": null
  },
  "forgehaus-tank-500-stainless-steel-bash-plates": {
    "vehicles": [],
    "title": "TANK 500 & GWM ALPHA STAINLESS STEEL BASH PLATES",
    "years": null
  },
  "forgehaus-gwm-alpha-tank-500-nudge-bar": {
    "vehicles": [],
    "title": "SAVAGE GWM ALPHA & TANK 500 IMPACT NUDGE BAR",
    "years": null
  },
  "forgehaus-gwm-alpha-3d-moulded-floor-mats-copy": {
    "vehicles": [],
    "title": "BYD SEALION 6 - 3D MOULDED PROTECTION MATS COMBO",
    "years": null
  },
  "forgehaus-byd-shark-towkit-brake-controller-patch-harness": {
    "vehicles": [],
    "title": "STANDARD PLUG AND PLAY BRAKE CONTROLLER HARNESS SHARK 6 PREMIUM",
    "years": null
  },
  "forgehaus-phantom-platform-awning-brackets": {
    "vehicles": [],
    "title": "PHANTOM SERIES PLATFORM AWNING BRACKETS",
    "years": null
  },
  "forgehaus-gwm-tank-500-grill-blackout-pack": {
    "vehicles": [],
    "title": "GWM TANK 500 SOLID GRILLE BLACKOUT PACK",
    "years": null
  },
  "forgehaus-savage-fortress-rack": {
    "vehicles": [],
    "title": "SAVAGE FORTRESS UNIVERSAL ROLLER SHUTTER TUB RACK",
    "years": null
  },
  "forgehaus-tank-500-grill-3-pack": {
    "vehicles": [],
    "title": "TANK 500 GRILLE #3 BUNDLE",
    "years": null
  },
  "forgehaus-tank-300-under-trunk-storage-tray": {
    "vehicles": [],
    "title": "TANK 300 UNDER TRUNK STORAGE TRAY (not suitable for HEV, PHEV or Diesel model)",
    "years": null
  },
  "forgehaus-kings-tactic-satin-black-each-copy": {
    "vehicles": [],
    "title": "KINGS GROWLER",
    "years": null
  },
  "forgehaus-oppo-find-x8-pro-leather-trim-magsafe-case-modern-classy-design": {
    "vehicles": [],
    "title": "Oppo Find X8 Pro Leather-Trim MagSafe Case \u2013 Modern, Classy Design",
    "years": null
  },
  "forgehaus-oppo-find-x8-pro-case-magsafe-compatible-clear-black-matte": {
    "vehicles": [],
    "title": "Oppo Find X8 Pro Case - MagSafe Compatible (Clear/Black Matte)",
    "years": null
  },
  "forgehaus-tank-500-grill-insect-mesh": {
    "vehicles": [],
    "title": "Tank 500 Stainless Steel Radiator Protection Mesh Kit (6-Piece Set)",
    "years": null
  },
  "forgehaus-tank-500-awning-brackets": {
    "vehicles": [],
    "title": "TANK 500 AWNING BRACKETS",
    "years": null
  },
  "forgehaus-tank-300-oil-filter-not-suitible-for-hev": {
    "vehicles": [],
    "title": "TANK 300 OIL FILTER (NOT SUITIBLE FOR HEV)",
    "years": null
  },
  "forgehaus-17x9-12-hurricane-ii-satin-bronze": {
    "vehicles": [],
    "title": "KINGS HURRICANE II",
    "years": null
  },
  "forgehaus-gwm-alpha-hoopless-bullbar": {
    "vehicles": [],
    "title": "GWM ALPHA RAMPAGE HOOPLESS BULL BAR",
    "years": null
  },
  "forgehaus-gwm-alpha-blackout-pack": {
    "vehicles": [],
    "title": "GWM ALPHA BLACKOUT PACK",
    "years": null
  },
  "forgehaus-tank-500-bonnet-nose-blackout-gloss": {
    "vehicles": [],
    "title": "TANK 500 BONNET NOSE BLACKOUT (GLOSS)",
    "years": null
  },
  "forgehaus-tank-500-grill-blackout-pack": {
    "vehicles": [],
    "title": "TANK 500 GRILLE BLACKOUT COVER PACK",
    "years": null
  },
  "forgehaus-gwm-cannon-alpha-trail-master-snorkel": {
    "vehicles": [
      "gwm-cannon-alpha"
    ],
    "title": "GWM ALPHA/TANK 500 TRAIL MASTER SNORKEL \u2013 ULTIMATE OFF-ROAD AIR INTAKE SOLUTION",
    "years": null
  },
  "forgehaus-18x9-tactic-satin-black-each": {
    "vehicles": [],
    "title": "KINGS TACTIC SATIN BLACK (EACH)",
    "years": null
  },
  "forgehaus-gwm-alpha-mudflaps": {
    "vehicles": [],
    "title": "GWM ALPHA MUDFLAPS",
    "years": null
  },
  "forgehaus-carbon-offroad-winches-remote-control-plug-extension-kit-suit-v2-and-v3": {
    "vehicles": [],
    "title": "Carbon Offroad Winch Remote Control Plug Extension Kit - Suit V2 and V3",
    "years": null
  },
  "forgehaus-gwm-tank-500-armour-forged-bullbar-hooped": {
    "vehicles": [],
    "title": "GWM TANK 500 ARMOUR FORGED BULL BAR (HOOPED)",
    "years": null
  },
  "forgehaus-savage-7-razor-lights-rectangular": {
    "vehicles": [],
    "title": "SAVAGE 7\" RAZOR LED SPOT LIGHT DRIVING LIGHTS (RECTANGULAR) (PAIR)",
    "years": null
  },
  "forgehaus-byd-seal-alcantara-center-console-cover-black": {
    "vehicles": [],
    "title": "BYD SEAL ALCANTARA CENTRE CONSOLE COVER",
    "years": null
  },
  "forgehaus-gwm-cannon-savage-cup-holder-insert": {
    "vehicles": [],
    "title": "SAVAGE CUP HOLDER INSERT",
    "years": null
  },
  "forgehaus-gwm-cannon-tri-fold-tub-cover": {
    "vehicles": [
      "gwm-cannon"
    ],
    "title": "SAVAGE TRIFOLD STEALTH HARD LID COVER \u2013 GWM CANNON 2020+ TONNEAU",
    "years": [
      2020,
      2099
    ]
  },
  "forgehaus-savage-270-awning-with-built-in-lighting": {
    "vehicles": [],
    "title": "SAVAGE ROGUE 270\u00b0 FREESTANDING AWNING 2M \u2013 ULTIMATE SHELTER FOR ADVENTURERS",
    "years": null
  },
  "forgehaus-savage-rogue-270-freestanding-awning-2m-ultimate-shelter-for-adventurers-copy": {
    "vehicles": [],
    "title": "SAVAGE ROGUE 270XL FREESTANDING AWNING 2M \u2013 EXPANDED COVERAGE FOR MAXIMUM PROTECTION",
    "years": null
  },
  "forgehaus-tank-500-number-plate-water-tank": {
    "vehicles": [],
    "title": "TANK 500 Number plate water Tank 20L",
    "years": null
  },
  "forgehaus-body-mount-chop-mod-plate": {
    "vehicles": [],
    "title": "BODY MOUNT CHOP MOD PLATE",
    "years": null
  },
  "forgehaus-removal-of-tonneau-cover": {
    "vehicles": [],
    "title": "REMOVAL OF TONNEAU COVER",
    "years": null
  },
  "forgehaus-gwm-alpha-tailgate-blackout": {
    "vehicles": [],
    "title": "GWM ALPHA TAILGATE BLACKOUT COVER",
    "years": null
  },
  "forgehaus-tank-300-ultimate-boot-protection-bundle": {
    "vehicles": [],
    "title": "TANK 300 ULTIMATE BOOT PROTECTION BUNDLE (does not suit PHEV)",
    "years": null
  },
  "forgehaus-tank-300-rear-seat-protection-covers": {
    "vehicles": [],
    "title": "TANK 300 REAR SEAT PROTECTION COVERS (Does not suit PHEV)",
    "years": null
  },
  "forgehaus-gwm-alpha-towkit-tow-bar-harness-plug-and-play": {
    "vehicles": [],
    "title": "GWM ALPHA TOWKIT TOW BAR HARNESS PLUG AND PLAY (NOT SUITABLE FOR PHEV)",
    "years": null
  },
  "forgehaus-gwm-alpha-door-handle-blackout-covers": {
    "vehicles": [],
    "title": "GWM ALPHA DOOR HANDLE BLACKOUT COVERS",
    "years": null
  },
  "forgehaus-gwm-alpha-mirror-blackout-covers": {
    "vehicles": [],
    "title": "GWM ALPHA MIRROR BLACKOUT COVERS",
    "years": null
  },
  "forgehaus-tank-300-tailgate-filters": {
    "vehicles": [],
    "title": "TANK 300 TAILGATE FILTERS",
    "years": null
  },
  "forgehaus-byd-sealion-6-savage-sunshade": {
    "vehicles": [],
    "title": "BYD SEALION 6 SAVAGE SUN SHADE VISOR",
    "years": null
  },
  "forgehaus-gwm-cannon-alpha-savageguard-manual-roller-shutter": {
    "vehicles": [
      "gwm-cannon-alpha"
    ],
    "title": "GWM ALPHA SAVAGEGUARD MANUAL ROLLER SHUTTER WITH PIN CODE LOCK",
    "years": null
  },
  "forgehaus-gwm-tank-500-premium-platform": {
    "vehicles": [],
    "title": "SAVAGE PHANTOM SERIES ROOF PLATFORM - GWM TANK 500 2023+ ALL MODELS",
    "years": [
      2023,
      2099
    ]
  },
  "forgehaus-tank-300-iridium-spark-plugs-4-pack": {
    "vehicles": [],
    "title": "GWM TANK 300 DOUBLE IRIDIUM SPARK PLUGS 4 PACK",
    "years": null
  },
  "forgehaus-official-tank-survival-shovel": {
    "vehicles": [],
    "title": "OFFICIAL TANK SURVIVAL SHOVEL",
    "years": null
  },
  "forgehaus-tank-300-subwoofer": {
    "vehicles": [],
    "title": "TANK 300 ACTIVE SUBWOOFER",
    "years": null
  },
  "forgehaus-tank-300-air-con-filter": {
    "vehicles": [],
    "title": "TANK 300 AIR CON FILTER",
    "years": null
  },
  "forgehaus-trailer-adaptor-13pin-to-12pin": {
    "vehicles": [],
    "title": "TOWKIT TRAILER ADAPTOR 13PIN TO 12PIN",
    "years": null
  },
  "forgehaus-tank-300-wireless-charger-phone-mount-combo": {
    "vehicles": [],
    "title": "TANK 300 PHONE HOLDER & MAGSNAP 15W WIRELESS CHARGER COMBO",
    "years": null
  },
  "forgehaus-tank-500-grill-1-bundle": {
    "vehicles": [],
    "title": "TANK 500 GRILLE 1 COMBO",
    "years": null
  },
  "forgehaus-tank-300-oem-taillight-replacement": {
    "vehicles": [],
    "title": "TANK 300 OEM TAIL LIGHT REPLACEMENT",
    "years": null
  },
  "forgehaus-stepmate": {
    "vehicles": [],
    "title": "STEP MATE - TOW BALL STEP",
    "years": null
  },
  "forgehaus-gwm-alpha-savage-key-case": {
    "vehicles": [],
    "title": "SAVAGE KEY CASE GWM ALPHA",
    "years": null
  },
  "forgehaus-gwm-alpha-3d-moulded-floor-mats": {
    "vehicles": [],
    "title": "GWM ALPHA 3D MOULDED FLOOR MATS (NOT CANNON)",
    "years": null
  },
  "forgehaus-tank-300-automatic-door-closer-and-opener": {
    "vehicles": [],
    "title": "Tank 300 AUTOMATIC DOOR CLOSER AND OPENER",
    "years": null
  },
  "forgehaus-tank-500-weathershields-6-piece": {
    "vehicles": [],
    "title": "TANK 500 WEATHERSHIELDS 6 PIECE",
    "years": null
  },
  "forgehaus-tank-300-boot-storage-box": {
    "vehicles": [],
    "title": "SAVAGE OFFROAD TANK 300 STORAGE BOX",
    "years": null
  },
  "forgehaus-gwm-alpha-door-sill-protection-kit-8pce": {
    "vehicles": [],
    "title": "GWM ALPHA DOOR SILL PROTECTION KIT 8PCE",
    "years": null
  },
  "forgehaus-gwm-cannon-throttle-controller": {
    "vehicles": [],
    "title": "SAVAGE OFFROAD GWM/TANK/HAVAL THROTTLE CONTROLLER",
    "years": null
  },
  "forgehaus-falken-wildpeak-at3-265-70r18": {
    "vehicles": [],
    "title": "FALKEN WILDPEAK AT3 - 265/70R18 - SUPPLY AND FIT AT LOGANHOLME QLD",
    "years": null
  },
  "forgehaus-tyre-carrier-camera-cover": {
    "vehicles": [],
    "title": "Tank 300 TYRE CARRIER CAMERA COVER",
    "years": null
  },
  "forgehaus-hitch-pin": {
    "vehicles": [],
    "title": "HITCH PIN",
    "years": null
  },
  "forgehaus-tank-500-tow-bar": {
    "vehicles": [],
    "title": "TANK 500 TOW BAR",
    "years": null
  },
  "forgehaus-lockable-hitch-pin": {
    "vehicles": [],
    "title": "Anti-Rattle Hitch Pin With Lock",
    "years": null
  },
  "forgehaus-tow-ball": {
    "vehicles": [],
    "title": "TOWBALL",
    "years": null
  },
  "forgehaus-2000w-inverter-with-remote": {
    "vehicles": [],
    "title": "2000W 12V to 230V/240V PURE SINE WAVE INVERTER (with UPS Function)",
    "years": null
  },
  "forgehaus-kickass-power-box": {
    "vehicles": [],
    "title": "KICKASS MINI 12V CONTROL BOX - 2 x Anderson, 6 x USB & 3 x Cig Sockets",
    "years": null
  },
  "forgehaus-tank-500-model-car": {
    "vehicles": [],
    "title": "OFFICIAL TANK 500 MODEL CAR 1:18",
    "years": null
  },
  "forgehaus-tank-500-door-sill-protection-kit": {
    "vehicles": [],
    "title": "TANK 500 DOOR SILL PROTECTION KIT 10pce",
    "years": null
  },
  "forgehaus-falken-wildpeak-at3-265-70r17": {
    "vehicles": [],
    "title": "FALKEN WILDPEAK AT3 - 285/70R17 - SUPPLY AND FIT LOGANHOLME",
    "years": null
  },
  "forgehaus-17x9-12-snatch-light-gun-metal": {
    "vehicles": [],
    "title": "17x9 +12 - SNATCH",
    "years": null
  },
  "forgehaus-gwm-cannon-alpha-tow-bar": {
    "vehicles": [
      "gwm-cannon-alpha"
    ],
    "title": "GWM ALPHA TOW BAR (NOT SUITABLE FOR PHEV)",
    "years": null
  },
  "forgehaus-tank-500-seat-back-table": {
    "vehicles": [],
    "title": "GWM TANK 500 REAR SEAT TABLE",
    "years": null
  },
  "forgehaus-gwm-alpha-electric-roller-hard-tonneau-cover": {
    "vehicles": [],
    "title": "GWM ALPHA ROLLERVAULT ELECTRIC ROLLER/HARD TONNEAU COVER",
    "years": null
  },
  "forgehaus-tank-300-savage-sun-shade": {
    "vehicles": [],
    "title": "TANK 300 SAVAGE SUNSHADE",
    "years": null
  },
  "forgehaus-tank-500-savage-sunshade": {
    "vehicles": [],
    "title": "TANK 500 SAVAGE Sunshade",
    "years": null
  },
  "forgehaus-gwm-alpha-savage-sunshade": {
    "vehicles": [],
    "title": "GWM ALPHA SAVAGE SUN SHADE VISOR",
    "years": null
  },
  "forgehaus-tank-500-floor-mats-full-set": {
    "vehicles": [],
    "title": "TANK 500 Non-PHEV 3D Moulded Floor Mats Full Set 7 Seater (4 Rows)",
    "years": null
  },
  "forgehaus-haval-jolion-ultra-dashmat": {
    "vehicles": [],
    "title": "HAVAL JOLION ULTRA DASHMAT 2022+",
    "years": [
      2022,
      2099
    ]
  },
  "forgehaus-haval-jolion-lux-dashmat": {
    "vehicles": [],
    "title": "HAVAL JOLION LUX DASHMAT 2022+",
    "years": [
      2022,
      2099
    ]
  },
  "forgehaus-tank-300-savage-piggy-back": {
    "vehicles": [],
    "title": "TANK 300 SAVAGE PIGGY-BACK",
    "years": null
  },
  "forgehaus-2015-fordpx2-px3-ranger-deep-floor-mat-set-3d-moulded-3-piece-copy": {
    "vehicles": [],
    "title": "2023+ FORD RANGER NEXT GEN DEEP FLOOR MAT SET 3D MOULDED 3 PIECE",
    "years": [
      2023,
      2099
    ]
  },
  "forgehaus-tank-300-savage-tow-bar-harness-plug-and-play-7-pin": {
    "vehicles": [],
    "title": "TANK 300 PETROL SAVAGE TOWKIT TOW BAR HARNESS PLUG AND PLAY (NOT COMPATIBLE WITH HYBRID HEV OR DIESEL)",
    "years": null
  },
  "forgehaus-tank-500-savage-plug-and-play-tow-bar-harness-7-pin": {
    "vehicles": [],
    "title": "TANK 500 SAVAGE TOWKIT PLUG AND PLAY TOW BAR HARNESS",
    "years": null
  },
  "forgehaus-magnetic-phone-holder-or-uhf-mic-holder": {
    "vehicles": [],
    "title": "UNIVERSAL MAGNETIC PHONE / UHF MIC HOLDER",
    "years": null
  },
  "forgehaus-tank-500-uhf-antenna-rear-door-mount": {
    "vehicles": [],
    "title": "TANK 500 UHF ANTENNA REAR DOOR MOUNT",
    "years": null
  },
  "forgehaus-tank-500-upgraded-led-headlights": {
    "vehicles": [],
    "title": "TANK 500 UPGRADED LED HEADLIGHTS",
    "years": null
  },
  "forgehaus-tank-300-500-key-case-suede": {
    "vehicles": [],
    "title": "TANK 300 & 500 KEY CASE ALCANTARA",
    "years": null
  },
  "forgehaus-towing-kit": {
    "vehicles": [],
    "title": "Tow Bar Hitch Kit Towball Hitch and Pin",
    "years": null
  },
  "forgehaus-byd-seal-2-peice-console-storage": {
    "vehicles": [],
    "title": "BYD SEAL 2 PEICE CENTRE CONSOLE STORAGE",
    "years": null
  },
  "forgehaus-byd-seal-1-peice-storage": {
    "vehicles": [],
    "title": "BYD SEAL 1 PEICE CENTRE CONSOLE STORAGE",
    "years": null
  },
  "forgehaus-tank-300-premium-bonnet-protector": {
    "vehicles": [],
    "title": "TANK 300 MOULDED BONNET PROTECTOR",
    "years": null
  },
  "forgehaus-byd-seal-2024-floor-mat-kit": {
    "vehicles": [],
    "title": "BYD SEAL 2024 11-PIECE FLOOR MAT KIT \u2013 PREMIUM PROTECTION WITH CARPET INSERT",
    "years": null
  },
  "forgehaus-untitled-16apr_08-18": {
    "vehicles": [],
    "title": "WIRELESS BLUETOOTH HEADPHONES WITH ANC AND LCD CASE",
    "years": null
  },
  "forgehaus-savage-platform-wind-deflector": {
    "vehicles": [],
    "title": "SAVAGE PLATFORM WIND DEFLECTOR",
    "years": null
  },
  "forgehaus-tank-300-side-storage-boot-trunk-left-side-only-hybrid": {
    "vehicles": [],
    "title": "TANK 300 SIDE STORAGE BOOT TRUNK LEFT SIDE ONLY (does not suit PHEV)",
    "years": null
  },
  "forgehaus-18x9-barret-12": {
    "vehicles": [],
    "title": "KINGS BARRETT WHEEL",
    "years": null
  },
  "forgehaus-tank-300-stage-1-ecu-tune": {
    "vehicles": [],
    "title": "TANK 300 STAGE 1 ECU TUNE",
    "years": null
  },
  "forgehaus-tank-300-grab-handle-6-way-switch": {
    "vehicles": [],
    "title": "TANK 300 GRAB HANDLE 6 WAY LIGHT SWITCH",
    "years": null
  },
  "forgehaus-tank-300-1-5-lift-spacer-rear-only": {
    "vehicles": [],
    "title": "TANK 300 1.5\" LIFT SPACER REAR ONLY",
    "years": null
  },
  "forgehaus-tank-300-tyre-cover-gloss-black-with-black-logo": {
    "vehicles": [],
    "title": "TANK 300 TYRE COVER WITH BLACK LOGO",
    "years": null
  },
  "forgehaus-tank-300-savage-nudge-bar-with-optional-light-bar": {
    "vehicles": [],
    "title": "Tank 300 SAVAGE IMPACT NUDGE BAR (OPTIONAL LIGHT BAR AVAILABLE)For all Spec",
    "years": null
  },
  "forgehaus-tank-300-side-storage-boot-trunk-pair": {
    "vehicles": [],
    "title": "TANK 300 SIDE STORAGE BOOT TRUNK PAIR (does not suit PHEV or HEV)",
    "years": null
  },
  "forgehaus-untitled-15feb_12-56": {
    "vehicles": [],
    "title": "TANK 300 SAVAGE GRILLE 1",
    "years": null
  },
  "forgehaus-tank-300-grill-4": {
    "vehicles": [],
    "title": "TANK 300 GRILLE 4",
    "years": null
  },
  "forgehaus-haval-h6-ultra-dashmat": {
    "vehicles": [],
    "title": "HAVAL H6/GT ULTRA DASHMAT",
    "years": null
  },
  "forgehaus-haval-h6-dash-mat": {
    "vehicles": [],
    "title": "HAVAL H6 LUX & PREMIUM DASHMAT",
    "years": null
  },
  "forgehaus-ldv-t60-dash-mat": {
    "vehicles": [],
    "title": "LDV T60 DASHMAT",
    "years": null
  },
  "forgehaus-untitled-6feb_14-52": {
    "vehicles": [],
    "title": "GWM Tank 300 DASHMAT",
    "years": null
  },
  "forgehaus-tank-300-key-case-heavy-duty": {
    "vehicles": [],
    "title": "TANK 300 & 500 KEY CASE HEAVY DUTY",
    "years": null
  },
  "forgehaus-savage-roller-shutter-platform": {
    "vehicles": [],
    "title": "SAVAGE ROLLER SHUTTER TUB RACK",
    "years": null
  },
  "forgehaus-tank-300-uhf-microphone-holder": {
    "vehicles": [],
    "title": "TANK 300 UHF MICROPHONE HOLDER",
    "years": null
  },
  "forgehaus-tank-300-silicone-intercooler-hoses": {
    "vehicles": [],
    "title": "TANK 300 SILICONE INTERCOOLER HOSES PETROL 2L ONLY",
    "years": null
  },
  "forgehaus-gwm-tank-300-stainless-underbody-bash-plates": {
    "vehicles": [],
    "title": "TANK 300 STAINLESS UNDERBODY BASH PLATES (3 Piece)",
    "years": null
  },
  "forgehaus-gwm-tank-300-silicone-key-cover-case": {
    "vehicles": [],
    "title": "GWM TANK 300 & 500 SILICONE KEY COVER/CASE",
    "years": null
  },
  "forgehaus-gwm-tank-300-dog-centre-harness": {
    "vehicles": [],
    "title": "TANK 300 DOG CENTRE HARNESS",
    "years": null
  },
  "forgehaus-tank-300-performance-air-filter": {
    "vehicles": [],
    "title": "TANK 300 PERFORMANCE AIR FILTER",
    "years": null
  },
  "forgehaus-universal-ladder-rack": {
    "vehicles": [],
    "title": "UNIVERSAL LADDER RACK",
    "years": null
  },
  "forgehaus-tank-300-grill-mesh": {
    "vehicles": [],
    "title": "TANK 300 INSECT GRILLE MESH",
    "years": null
  },
  "forgehaus-tank-300-towbar": {
    "vehicles": [],
    "title": "TANK 300 TOW BAR",
    "years": null
  },
  "forgehaus-gwm-tank-300-grill-with-tank-logo-2": {
    "vehicles": [],
    "title": "GWM TANK 300 GRILLE with \"TANK\" logo #2",
    "years": null
  },
  "forgehaus-tank-300-sway-bar-relocation-kit": {
    "vehicles": [],
    "title": "TANK 300 SWAY BAR RELOCATION KIT",
    "years": null
  },
  "forgehaus-tank-300-recovery-points": {
    "vehicles": [],
    "title": "TANK 300 RECOVERY POINTS",
    "years": null
  },
  "forgehaus-gwm-tank-300-extended-rear-bump-stops": {
    "vehicles": [],
    "title": "GWM TANK 300 EXTENDED REAR BUMP STOPS",
    "years": null
  },
  "forgehaus-sports-bar-adapter-feet-1": {
    "vehicles": [],
    "title": "Sports Bar Bracket Adapter Feet",
    "years": null
  },
  "forgehaus-gwm-tank-300-fmic-upgrade": {
    "vehicles": [],
    "title": "GWM TANK 300 FMIC UPGRADE (Intercooler)",
    "years": null
  },
  "forgehaus-body-mount-chop": {
    "vehicles": [],
    "title": "Body Mount Chop",
    "years": null
  },
  "forgehaus-towbar-wiring-harness": {
    "vehicles": [],
    "title": "UNIVERSAL TOWBAR WIRING HARNESS",
    "years": null
  },
  "forgehaus-tank-300-armour-hoopless-bullbar": {
    "vehicles": [],
    "title": "TANK 300 ARMOUR (HOOPLESS) BULL BAR FOR ALL MODELS",
    "years": null
  },
  "forgehaus-tank-300-electronic-sway-bar": {
    "vehicles": [],
    "title": "GWM TANK 300 ELECTRONIC SWAY BAR",
    "years": null
  },
  "forgehaus-tank-300-boot-3d-moulded-mat": {
    "vehicles": [],
    "title": "TANK 300 BOOT 3D MOULDED MAT (Does not suit PHEV)",
    "years": null
  },
  "forgehaus-gwm-cannon-electric-side-steps": {
    "vehicles": [
      "gwm-cannon"
    ],
    "title": "GWM CANNON SAVAGE ELECTRIC SMARTSTEP SIDE STEPS",
    "years": null
  },
  "forgehaus-tank-300-front-grill-logo-blackout-cover": {
    "vehicles": [],
    "title": "TANK 300 Front Grill Logo Blackout Cover",
    "years": null
  },
  "forgehaus-tank-300-taillight-covers": {
    "vehicles": [],
    "title": "TANK 300 TAIL LIGHT COVERS",
    "years": null
  },
  "forgehaus-2ch-8ga-amplifier-wiring-kit": {
    "vehicles": [],
    "title": "2CH 8GA UNDERSEAT SUBWOOFER WIRING KIT",
    "years": null
  },
  "forgehaus-tank-300-bonnet-protector": {
    "vehicles": [],
    "title": "TANK 300 BONNET PROTECTOR",
    "years": null
  },
  "forgehaus-tank-300-weathershield-a": {
    "vehicles": [],
    "title": "TANK 300 BLACK WEATHERSHIELDS",
    "years": null
  },
  "forgehaus-tank-300-uhf-antenna-rear-door-mount": {
    "vehicles": [],
    "title": "TANK 300 UHF ANTENNA REAR DOOR MOUNT",
    "years": null
  },
  "forgehaus-tank-300-ladder": {
    "vehicles": [],
    "title": "TANK 300 SIDE LADDER TO SUIT RAILPRO ROOF PLATFORM (Not suitable for PHEV)",
    "years": null
  },
  "forgehaus-tank300-front-2-lift-spacer": {
    "vehicles": [],
    "title": "TANK 300  FRONT 1.5\" LIFT SPACER",
    "years": null
  },
  "forgehaus-tank-300-platform-rack-ful-length": {
    "vehicles": [],
    "title": "TANK 300 SAVAGE  RAILPRO ROOF PLATFORM",
    "years": null
  },
  "forgehaus-copy-of-gwm-cannon-tailagte-lock-hsp": {
    "vehicles": [],
    "title": "LDV T60 TAILGATE LOCK HSP",
    "years": null
  },
  "forgehaus-savage-600w-10-under-seat-subwoofer": {
    "vehicles": [],
    "title": "SAVAGE 600w 10\" Under-Seat Subwoofer",
    "years": null
  },
  "forgehaus-byd-atto-3-deep-floor-mats-full-sets": {
    "vehicles": [],
    "title": "BYD ATTO-3 DEEP 3D MOULDED FLOOR MATS FULL SETS",
    "years": null
  },
  "forgehaus-haval-h6-towbar": {
    "vehicles": [],
    "title": "HAVAL H6 TOW BAR",
    "years": null
  },
  "forgehaus-tank-300-3d-deep-floor-mats": {
    "vehicles": [],
    "title": "GWM Tank 300 3D Deep All Weather Floor Mats | Full Front & Rear Set (does not suit PHEV)",
    "years": null
  },
  "forgehaus-tank-300-extended-ball-joints": {
    "vehicles": [],
    "title": "TANK 300 EXTENDED BALL JOINTS",
    "years": null
  },
  "forgehaus-tank-300-flare-kit": {
    "vehicles": [],
    "title": "Tank 300 Rear Door Mud Guards",
    "years": null
  },
  "forgehaus-manual-roller-shutter-for-ldv-t60": {
    "vehicles": [],
    "title": "LDV T60 MANUAL ROLLER SHUTTER/HARD TONNEAU COVER",
    "years": null
  },
  "forgehaus-premium-tub-rack-half-height": {
    "vehicles": [],
    "title": "SAVAGE PREMIUM UNIVERSAL HALF-HEIGHT TUB RACK",
    "years": null
  },
  "forgehaus-gwm-cannon-savage-fuel-bash-plate": {
    "vehicles": [
      "gwm-cannon"
    ],
    "title": "GWM CANNON 2020+ SAVAGE DIESEL FILTER BASH PLATE",
    "years": [
      2020,
      2099
    ]
  },
  "forgehaus-anderson-plug-50ah-cover": {
    "vehicles": [],
    "title": "ANDERSON PLUG 50AH COVER",
    "years": null
  },
  "forgehaus-copy-of-battery-red-cable-16mm-per-m": {
    "vehicles": [],
    "title": "BATTERY CABLE BLACK 16MM PER M",
    "years": null
  },
  "forgehaus-copy-of-battery-cable-25mm-per-m": {
    "vehicles": [],
    "title": "BATTERY CABLE BLACK 25MM PER M",
    "years": null
  },
  "forgehaus-battery-cable-16mm-per-m": {
    "vehicles": [],
    "title": "BATTERY CABLE RED16MM PER M",
    "years": null
  },
  "forgehaus-battery-cable": {
    "vehicles": [],
    "title": "BATTERY CABLE RED 25MM PER M",
    "years": null
  },
  "forgehaus-haval-h6-gt-towbar": {
    "vehicles": [],
    "title": "HAVAL H6 GT TOW BAR",
    "years": null
  },
  "forgehaus-toyota-land-cruiser-lc76-roof-platform-with-integrated-light-bar": {
    "vehicles": [],
    "title": "TOYOTA LAND CRUISER LC76 ROOF PLATFORM WITH INTEGRATED LIGHT BAR",
    "years": null
  },
  "forgehaus-gwm-cannon-rated-recovery-points": {
    "vehicles": [],
    "title": "GWM CANNON RED RECOVERY POINTS",
    "years": null
  },
  "forgehaus-toyota-lc300-weather-shields-tinted": {
    "vehicles": [],
    "title": "TOYOTA LC300 WEATHER SHIELDS TINTED",
    "years": null
  },
  "forgehaus-vanta-sports-bar-template": {
    "vehicles": [],
    "title": "VANTA/XSR SPORTS BAR FITTING KIT 2020-2024",
    "years": [
      2020,
      2024
    ]
  },
  "forgehaus-gwm-cannon-carry-lid-torneau": {
    "vehicles": [
      "gwm-cannon"
    ],
    "title": "GWM CANNON CARRY LID COVER/HARD TONNEAU COVER",
    "years": null
  },
  "forgehaus-byd-atto3-premium-tinted-weathershield-with-black-trim": {
    "vehicles": [],
    "title": "BYD ATTO3 PREMIUM TINTED WEATHERSHIELD (With Black Trim)",
    "years": null
  },
  "forgehaus-byd-atto3-boot-3d-moulded-mat": {
    "vehicles": [],
    "title": "BYD ATTO3 BOOT 3D MOULDED MAT",
    "years": null
  },
  "forgehaus-haval-h6-bonnet-protector": {
    "vehicles": [],
    "title": "Haval H6 BONNET PROTECTOR",
    "years": null
  },
  "forgehaus-universal-platform": {
    "vehicles": [],
    "title": "Universal platform",
    "years": null
  },
  "forgehaus-tie-down-eyelet-platform-bolt": {
    "vehicles": [],
    "title": "Tie down eyelet platform bolt",
    "years": null
  },
  "forgehaus-haval-jolion-boot-3d-moulded-mat": {
    "vehicles": [],
    "title": "HAVAL JOLION BOOT 3D MOULDED MAT (Does not fit HEV models OR 2025 models)",
    "years": null
  },
  "forgehaus-haval-jolion-weather-shield": {
    "vehicles": [],
    "title": "HAVAL JOLION WEATHERSHIELD 2021+",
    "years": [
      2021,
      2099
    ]
  },
  "forgehaus-haval-jolion-3d-deep-floor-mat": {
    "vehicles": [],
    "title": "Haval Jolion 3D Deep Floor Mats",
    "years": null
  },
  "forgehaus-haval-h6-3d-deep-floor-mat": {
    "vehicles": [],
    "title": "Haval H6 & H6 GT 3D Deep Floor Mats",
    "years": null
  },
  "forgehaus-gwm-cannon-black-nudge-bar": {
    "vehicles": [],
    "title": "GWM CANNON IMPACT ALLOY NUDGE BAR (RECOVERY POINT COMPATIBLE)",
    "years": null
  },
  "forgehaus-haval-h6-weather-shield": {
    "vehicles": [],
    "title": "HAVAL H6 AND H6GT PREMIUM WEATHER SHIELD BLACK FRAME 2021+",
    "years": [
      2021,
      2099
    ]
  },
  "forgehaus-haval-h6-boot-3d-moulded-mat": {
    "vehicles": [],
    "title": "HAVAL H6  & H6 GT BOOT 3D MOULDED MAT",
    "years": null
  },
  "forgehaus-gwm-cannon-manual-roller-shutter": {
    "vehicles": [
      "gwm-cannon"
    ],
    "title": "GWM CANNON MANUAL SAVAGE ROLLERVAULT ROLLER SHUTTER/HARD TONNEAU COVER FOR ALL MODELS",
    "years": null
  },
  "byd-shark-6-savage-attack-hooped-bull-bar": {
    "vehicles": [
      "byd-shark-6"
    ],
    "title": "BYD SHARK 6 SAVAGE ATTACK HOOPED BULL BAR",
    "years": null
  },
  "byd-shark-6-savage-attack-hoopless-bull-bar": {
    "vehicles": [
      "byd-shark-6"
    ],
    "title": "BYD SHARK 6 SAVAGE ATTACK HOOPLESS BULL BAR",
    "years": null
  },
  "byd-shark-6-savage-electric-smartsteps-side-steps": {
    "vehicles": [
      "byd-shark-6"
    ],
    "title": "BYD SHARK 6 SAVAGE ELECTRIC SMARTSTEPS SIDE STEPS",
    "years": null
  },
  "byd-shark-6-electric-cargoguard-v3-pro-roller-shutter": {
    "vehicles": [
      "byd-shark-6"
    ],
    "title": "BYD SHARK 6 ELECTRIC CARGOGUARD V3 PRO ROLLER SHUTTER",
    "years": null
  },
  "byd-shark-6-manual-cargoguard-v3-base-roller-shutter": {
    "vehicles": [
      "byd-shark-6"
    ],
    "title": "BYD SHARK 6 MANUAL CARGOGUARD V3 BASE ROLLER SHUTTER",
    "years": null
  },
  "savage-phantom-series-roof-platform-byd-shark-6": {
    "vehicles": [
      "byd-shark-6"
    ],
    "title": "SAVAGE PHANTOM SERIES ROOF PLATFORM \u2013 BYD SHARK 6",
    "years": null
  },
  "byd-shark-6-savage-trifold-stealth-hard-lid-cover-tonneau": {
    "vehicles": [
      "byd-shark-6"
    ],
    "title": "BYD SHARK 6 SAVAGE TRIFOLD STEALTH HARD LID COVER (TONNEAU)",
    "years": null
  },
  "byd-shark-6-fender-flares-savage-predator-30mm-widebody-kit": {
    "vehicles": [
      "byd-shark-6"
    ],
    "title": "BYD SHARK 6 FENDER FLARES SAVAGE PREDATOR 30MM WIDEBODY KIT",
    "years": null
  },
  "byd-shark-6-rogue-floor-slide": {
    "vehicles": [
      "byd-shark-6"
    ],
    "title": "BYD SHARK 6 ROGUE FLOOR SLIDE",
    "years": null
  },
  "savage-tech-alloy-5mm-molle-side-storage-for-byd-shark": {
    "vehicles": [
      "byd-shark-6"
    ],
    "title": "SAVAGE TECH ALLOY 5MM MOLLE SIDE STORAGE FOR BYD SHARK",
    "years": null
  },
  "savage-recovery-points-byd-shark-6": {
    "vehicles": [
      "byd-shark-6"
    ],
    "title": "SAVAGE RECOVERY POINTS BYD SHARK 6",
    "years": null
  },
  "gwm-cannon-beast-hooped-bull-bar-2020-2026": {
    "vehicles": [
      "gwm-cannon"
    ],
    "title": "GWM CANNON BEAST HOOPED BULL BAR 2020-2026",
    "years": [
      2020,
      2026
    ]
  },
  "gwm-cannon-the-beast-hoopless-bull-bar-2020-2024-v2": {
    "vehicles": [
      "gwm-cannon"
    ],
    "title": "GWM CANNON \"THE BEAST\" HOOPLESS BULL BAR 2020-2024 V2",
    "years": [
      2020,
      2024
    ]
  },
  "gwm-cannon-impact-alloy-nudge-bar": {
    "vehicles": [
      "gwm-cannon"
    ],
    "title": "GWM CANNON IMPACT ALLOY NUDGE BAR",
    "years": null
  },
  "gwm-cannon-savage-offroad-2-reverb-pro-suspension-lift-kit-2020-2025": {
    "vehicles": [
      "gwm-cannon"
    ],
    "title": "GWM CANNON SAVAGE OFFROAD 2\" REVERB PRO SUSPENSION LIFT KIT (2020-2025+)",
    "years": [
      2020,
      2025
    ]
  },
  "savage-upper-control-arms-suits-gwm-cannon-tank-300": {
    "vehicles": [
      "gwm-cannon"
    ],
    "title": "SAVAGE UPPER CONTROL ARMS \u2013 SUITS GWM CANNON & TANK 300",
    "years": null
  },
  "gwm-cannon-trail-master-snorkel-2020-2025": {
    "vehicles": [
      "gwm-cannon"
    ],
    "title": "GWM CANNON TRAIL MASTER SNORKEL (2020-2025+)",
    "years": [
      2020,
      2025
    ]
  },
  "gwm-cannon-manual-savage-rollervault-roller-shutter-hard-tonneau": {
    "vehicles": [
      "gwm-cannon"
    ],
    "title": "GWM CANNON MANUAL SAVAGE ROLLERVAULT ROLLER SHUTTER / HARD TONNEAU",
    "years": null
  },
  "savage-cargoguard-pro-electric-roller-gwm-cannon-2020": {
    "vehicles": [
      "gwm-cannon"
    ],
    "title": "SAVAGE CARGOGUARD PRO ELECTRIC ROLLER \u2013 GWM CANNON 2020+",
    "years": [
      2020,
      2099
    ]
  },
  "gwm-cannon-flat-pack-alloy-aluminium-canopy-with-central-locking": {
    "vehicles": [
      "gwm-cannon"
    ],
    "title": "GWM CANNON FLAT PACK ALLOY/ALUMINIUM CANOPY WITH CENTRAL LOCKING",
    "years": null
  },
  "savage-phantom-series-roof-platform-gwm-cannon-2020": {
    "vehicles": [
      "gwm-cannon"
    ],
    "title": "SAVAGE PHANTOM SERIES ROOF PLATFORM \u2013 GWM CANNON 2020+",
    "years": [
      2020,
      2099
    ]
  },
  "gwm-cannon-savage-vert-rear-bar-with-tow-bar-hitch-receiver": {
    "vehicles": [
      "gwm-cannon"
    ],
    "title": "GWM CANNON SAVAGE VERT REAR BAR WITH TOW BAR HITCH RECEIVER",
    "years": null
  },
  "gwm-cannon-tow-bar-kit-2020-base-l-x-vanta-ultra-incl-facelift": {
    "vehicles": [
      "gwm-cannon"
    ],
    "title": "GWM CANNON TOW BAR KIT (2020+, Base/L/X/Vanta/Ultra incl. facelift)",
    "years": [
      2020,
      2099
    ]
  },
  "gwm-cannon-savage-diesel-filter-bash-plate-2020": {
    "vehicles": [
      "gwm-cannon"
    ],
    "title": "GWM CANNON SAVAGE DIESEL FILTER BASH PLATE (2020+)",
    "years": [
      2020,
      2099
    ]
  },
  "savage-phantom-series-roof-platform-denza-b8-2026": {
    "vehicles": [
      "denza-b8"
    ],
    "title": "SAVAGE PHANTOM SERIES ROOF PLATFORM \u2013 DENZA B8 (2026+)",
    "years": [
      2026,
      2099
    ]
  },
  "savage-phantom-series-roof-platform-denza-b5-2026": {
    "vehicles": [
      "denza-b5"
    ],
    "title": "SAVAGE PHANTOM SERIES ROOF PLATFORM \u2013 DENZA B5 (2026+)",
    "years": [
      2026,
      2099
    ]
  },
  "denza-b5-savage-railpro-roof-platform-with-storage-box": {
    "vehicles": [
      "denza-b5"
    ],
    "title": "DENZA B5 SAVAGE RAILPRO ROOF PLATFORM WITH STORAGE BOX",
    "years": null
  },
  "savage-electric-smartsteps-side-steps-w-rgb-step-lighting-denza-b5-2026": {
    "vehicles": [
      "denza-b5"
    ],
    "title": "SAVAGE ELECTRIC SMARTSTEPS SIDE STEPS W/ RGB STEP LIGHTING \u2013 DENZA B5 (2026+)",
    "years": [
      2026,
      2099
    ]
  },
  "savage-electric-smartsteps-side-steps-w-rgb-step-lighting-denza-b8-2026": {
    "vehicles": [
      "denza-b8"
    ],
    "title": "SAVAGE ELECTRIC SMARTSTEPS SIDE STEPS W/ RGB STEP LIGHTING \u2013 DENZA B8 (2026+)",
    "years": [
      2026,
      2099
    ]
  },
  "savage-full-armour-aluminium-under-body-bash-plate-kit-denza-b8-2026": {
    "vehicles": [
      "denza-b8"
    ],
    "title": "SAVAGE FULL ARMOUR ALUMINIUM UNDER BODY BASH PLATE KIT \u2013 DENZA B8 (2026+)",
    "years": [
      2026,
      2099
    ]
  },
  "savage-full-armour-aluminium-under-body-bash-plate-kit-denza-b5-2026": {
    "vehicles": [
      "denza-b5"
    ],
    "title": "SAVAGE FULL ARMOUR ALUMINIUM UNDER BODY BASH PLATE KIT \u2013 DENZA B5 (2026+)",
    "years": [
      2026,
      2099
    ]
  },
  "savage-premium-universal-full-height-tub-rack": {
    "vehicles": [],
    "title": "Savage Premium Universal Full-Height Tub Rack",
    "years": null
  },
  "savage-phantom-sports-bar-v2": {
    "vehicles": [],
    "title": "Savage Phantom Sports Bar V2",
    "years": null
  },
  "gwm-cannon-tub-rack-with-side-storage-box-2020": {
    "vehicles": [
      "gwm-cannon"
    ],
    "title": "Gwm Cannon Tub Rack With Side Storage Box 2020+",
    "years": [
      2020,
      2099
    ]
  },
  "savage-terra-forged-wheels-denza-b8-leopard-b5-18x8-5-6x139-7-multiple-colours": {
    "vehicles": [
      "denza-b5",
      "denza-b8"
    ],
    "title": "Savage Terra Forged Wheels Denza B8 Leopard B5 18X8.5 6X139.7 Multiple Colours",
    "years": null
  },
  "120l-long-range-fuel-tank-byd-shark-6-2025": {
    "vehicles": [
      "byd-shark-6"
    ],
    "title": "120L Long Range Fuel Tank \u2013 Byd Shark 6 2025+",
    "years": [
      2025,
      2099
    ]
  },
  "savage-phantom-series-side-ladder-denza-b5-2026": {
    "vehicles": [
      "denza-b5"
    ],
    "title": "Savage Phantom Series Side Ladder Denza B5 2026+",
    "years": [
      2026,
      2099
    ]
  },
  "108l-long-range-fuel-tank-upgrade-for-gwm-cannon": {
    "vehicles": [
      "gwm-cannon"
    ],
    "title": "108L Long-Range Fuel Tank Upgrade For Gwm Cannon",
    "years": null
  },
  "savage-hard-carry-load-lid-byd-shark-6": {
    "vehicles": [
      "byd-shark-6"
    ],
    "title": "Savage Hard Carry-Load Lid Byd Shark 6",
    "years": null
  },
  "gwm-cannon-reverb-front-suspension-lift-only": {
    "vehicles": [
      "gwm-cannon"
    ],
    "title": "Gwm Cannon Reverb Front Suspension Lift Only",
    "years": null
  },
  "gwm-cannon-savage-omega-2-2-5-suspension-kit": {
    "vehicles": [
      "gwm-cannon"
    ],
    "title": "Gwm Cannon Savage Omega 2-2.5\" Suspension Kit",
    "years": null
  },
  "gwm-cannon-beast-hooped-bull-bar-2020-2026-fits-all-models-2-0l-2-4l": {
    "vehicles": [
      "gwm-cannon"
    ],
    "title": "Gwm Cannon Beast Hooped Bull Bar 2020-2026 Fits All Models 2.0L/2.4L",
    "years": [
      2020,
      2026
    ]
  },
  "gwm-cannon-2020-savage-edge-rocksliders": {
    "vehicles": [
      "gwm-cannon"
    ],
    "title": "Gwm Cannon 2020+ Savage Edge Rocksliders",
    "years": [
      2020,
      2099
    ]
  },
  "gwm-cannon-savage-apex-nitrogen-suspension-lift-kit": {
    "vehicles": [
      "gwm-cannon"
    ],
    "title": "Gwm Cannon Savage Apex Nitrogen Suspension Lift Kit",
    "years": null
  },
  "wetseat-neoprene-seat-covers-for-gwm-cannon-x-vanta-xsr-full-set-front-rear-australian-made": {
    "vehicles": [
      "gwm-cannon"
    ],
    "title": "Wetseat Neoprene Seat Covers For Gwm Cannon X\u202f/\u202fVanta\u202f/\u202fXsr \u2013 Full Set Front & Rear (Australian Made)",
    "years": null
  },
  "byd-shark-6-savage-edge-rocksliders": {
    "vehicles": [
      "byd-shark-6"
    ],
    "title": "Byd Shark 6 Savage Edge Rocksliders",
    "years": null
  },
  "gwm-cannon-trx-style-bonnet": {
    "vehicles": [
      "gwm-cannon"
    ],
    "title": "Gwm Cannon Trx Style Bonnet",
    "years": null
  },
  "byd-shark-6-hsp-load-slide": {
    "vehicles": [
      "byd-shark-6"
    ],
    "title": "Byd Shark 6 Hsp Load Slide",
    "years": null
  },
  "byd-shark-6-warrior-wheel-tyre-package": {
    "vehicles": [
      "byd-shark-6"
    ],
    "title": "Byd Shark 6 Warrior Wheel & Tyre Package",
    "years": null
  },
  "gwm-cannon-fmic-upgrade-intercooler": {
    "vehicles": [
      "gwm-cannon"
    ],
    "title": "Gwm Cannon Fmic Upgrade (Intercooler)",
    "years": null
  },
  "savage-phantom-series-roof-platform-gwm-cannon-2020-including-face-lift-does-not-fit-alpha": {
    "vehicles": [
      "gwm-cannon"
    ],
    "title": "Savage Phantom Series Roof Platform - Gwm Cannon 2020+ Including Face Lift (Does Not Fit Alpha)",
    "years": [
      2020,
      2099
    ]
  },
  "gwm-cannon-savage-led-platform-bundle": {
    "vehicles": [
      "gwm-cannon"
    ],
    "title": "Gwm Cannon Savage Led Platform Bundle",
    "years": null
  },
  "cannon-tank-300-alpha-gvm-upgrade-mod-plate": {
    "vehicles": [],
    "title": "Cannon / Tank 300 / Alpha -  Gvm Upgrade Mod Plate",
    "years": null
  },
  "gwm-cannon-xsr-dual-cab-tow-bar-2023": {
    "vehicles": [
      "gwm-cannon"
    ],
    "title": "Gwm Cannon Xsr Dual Cab Tow Bar 2023+",
    "years": [
      2023,
      2099
    ]
  },
  "gwm-cannon-stainless-steel-savage-underbody-bash-plates-3-piece-2020-2024": {
    "vehicles": [
      "gwm-cannon"
    ],
    "title": "Gwm Cannon Stainless Steel Savage Underbody Bash Plates ( 3 Piece) 2020-2024",
    "years": [
      2020,
      2024
    ]
  },
  "gwm-cannon-2020-tow-bar-for-base-l-x-vanta-ultra-including-facelift": {
    "vehicles": [
      "gwm-cannon"
    ],
    "title": "Gwm Cannon 2020+ Tow Bar For Base,L,X, Vanta & Ultra Including Facelift",
    "years": [
      2020,
      2099
    ]
  },
  "gwm-cannon-roof-rack-and-platform-system": {
    "vehicles": [
      "gwm-cannon"
    ],
    "title": "Gwm Cannon Roof Rack And Platform System",
    "years": null
  },
  "workshop-installation-service": {
    "vehicles": [],
    "title": "Workshop Installation Service",
    "years": null
  },
  "mobile-installation-service": {
    "vehicles": [],
    "title": "Mobile Installation Service",
    "years": null
  },
  "forgehaus-haval-h9-heavy-duty-towbar": {
    "vehicles": [],
    "title": "Haval H9 - HEAVY DUTY TOWBAR",
    "years": null
  },
  "forgehaus-savage-phantom-series-roof-platform-270-awning-brackets": {
    "vehicles": [],
    "title": "SAVAGE PHANTOM SERIES ROOF PLATFORM 270 AWNING BRACKETS",
    "years": null
  },
  "forgehaus-gwm-alpha-diesel-drive-shaft": {
    "vehicles": [],
    "title": "GWM ALPHA DIESEL DRIVE SHAFT",
    "years": null
  },
  "forgehaus-tank-500-spare-wheel-carrier-with-ladder": {
    "vehicles": [],
    "title": "TANK 500 SPARE WHEEL CARRIER WITH LADDER",
    "years": null
  },
  "forgehaus-12v-flush-mount-socket": {
    "vehicles": [],
    "title": "12V FLUSH MOUNT SOCKET",
    "years": null
  },
  "forgehaus-byd-sealion-6-2023-2025-wiper-blades-24-19-m3-1": {
    "vehicles": [],
    "title": "BYD SEALION 6 2023 - 2025 Wiper Blades - 24\"/19\" (M3)",
    "years": [
      2023,
      2025
    ]
  },
  "forgehaus-anderson-plug-50a-flush-mount": {
    "vehicles": [],
    "title": "ANDERSON PLUG 50A FLUSH MOUNT",
    "years": null
  },
  "byd-shark-6-tailgate-lip-protector": {
    "vehicles": [
      "byd-shark-6"
    ],
    "title": "Byd Shark 6 Tailgate Lip Protector",
    "years": null
  },
  "gwm-cannon-awning-brackets": {
    "vehicles": [
      "gwm-cannon"
    ],
    "title": "Gwm Cannon Awning Brackets",
    "years": null
  },
  "barbaro-cac-racing-c-60-front-brake-pads-for-gwm-cannon-2-4-tank-500": {
    "vehicles": [
      "gwm-cannon"
    ],
    "title": "Barbaro Cac Racing C-60 Front Brake Pads For Gwm Cannon 2.4 & Tank 500",
    "years": null
  },
  "byd-shark-6-bonnet-protector": {
    "vehicles": [
      "byd-shark-6"
    ],
    "title": "BYD SHARK 6 BONNET PROTECTOR",
    "years": null
  },
  "savage-3d-moulded-boot-mat-denza-b5-2026": {
    "vehicles": [
      "denza-b5"
    ],
    "title": "SAVAGE 3D MOULDED BOOT MAT \u2013 DENZA B5 (2026+)",
    "years": [
      2026,
      2099
    ]
  },
  "cleaning-cloth-reusable-and-washable": {
    "vehicles": [],
    "title": "Reusable Dual-Sided Cleaning Cloth",
    "years": null
  },
  "byd-shark-6-dashmat-black": {
    "vehicles": [
      "byd-shark-6"
    ],
    "title": "BYD SHARK 6 DASHMAT BLACK",
    "years": null
  },
  "gwm-cannon-x-vanta-xsr-dashmat-3d-moulded-2020-2024": {
    "vehicles": [
      "gwm-cannon"
    ],
    "title": "GWM CANNON X/VANTA & XSR DASHMAT 3D MOULDED (2020-2024)",
    "years": [
      2020,
      2024
    ]
  },
  "forgehaus-savage-drift-cart-brake-caliper": {
    "vehicles": [],
    "title": "SAVAGE DRIFT CART BRAKE CALIPER",
    "years": null
  },
  "forgehaus-savage-drift-kart-seat": {
    "vehicles": [],
    "title": "SAVAGE DRIFT KART SEAT",
    "years": null
  },
  "front-grille-emblem-decoration-sticker-for-byd-shark-6": {
    "vehicles": [
      "byd-shark-6"
    ],
    "title": "BYD Shark 6 Front-Grille Blackout Emblem Sticker",
    "years": null
  },
  "byd-shark-6-premium-performance-3d-moulded-tpe-floor-mats-door-sill-protection": {
    "vehicles": [
      "byd-shark-6"
    ],
    "title": "BYD SHARK 6 PREMIUM & PERFORMANCE 3D MOULDED TPE FLOOR MATS & DOOR SILL PROTECTION",
    "years": null
  },
  "gwm-cannon-led-bonnet-nose-installation-logan": {
    "vehicles": [
      "gwm-cannon"
    ],
    "title": "Gwm Cannon Led Bonnet Nose Installation (Logan)",
    "years": null
  },
  "car-neck-pillow-and-shoulder-guards": {
    "vehicles": [
      "byd-shark-6"
    ],
    "title": "BYD Shark 6 Neck Pillow and Shoulder-Pad Set",
    "years": null
  },
  "portable-foldable-car-windshield-sunshade": {
    "vehicles": [],
    "title": "Foldable Windscreen Sunshade",
    "years": null
  },
  "carbon-series-door-card-scuff-protectors-denza-b8-2026": {
    "vehicles": [
      "denza-b8"
    ],
    "title": "CARBON SERIES DOOR CARD SCUFF PROTECTORS \u2013 DENZA B8 (2026+)",
    "years": [
      2026,
      2099
    ]
  },
  "car-armrest-storage-box-for-byd-shark": {
    "vehicles": [
      "byd-shark-6"
    ],
    "title": "BYD Shark 6 Armrest Storage Box",
    "years": null
  },
  "byd-brand-chest-bag": {
    "vehicles": [],
    "title": "BYD Crossbody Chest Bag",
    "years": null
  }
};
  const key = 'forgehaus.vehicle.v1';
  const models = {BYD:[['Shark 6','byd-shark-6']],GWM:[['Cannon','gwm-cannon'],['Cannon Alpha','gwm-cannon-alpha']],Denza:[['B5','denza-b5'],['B8','denza-b8']]};
  const money = cents => new Intl.NumberFormat('en-AU',{style:'currency',currency:'AUD',minimumFractionDigits:0,maximumFractionDigits:2}).format(cents/100).replace('$','A$');
  let vehicle = null;
  try {vehicle=JSON.parse(localStorage.getItem(key));} catch (_) {}
  if (vehicle && (!Object.values(models).flat().some(m=>m[1]===vehicle.key) || (vehicle.year !== null && !/^202[0-6]$/.test(vehicle.year)))) vehicle=null;
  // Apply the saved model to the server-paginated result set, not only the
  // cards on page one. Client filtering additionally handles year exclusions.
  if(vehicle){
    const target=new URL(location.href);
    if(/^\/collections\/[^/]+\/?$/.test(target.pathname)){
      target.pathname=target.pathname.replace(/\/$/,'')+'/fh-vehicle-'+vehicle.key;
      location.replace(target.href);return;
    }
    if(target.pathname==='/search' && !(target.searchParams.get('q')||'').includes('tag:fh-vehicle-'+vehicle.key)){
      const q=(target.searchParams.get('q')||'').replace(/\s*AND\s*tag:fh-vehicle-[a-z0-9-]+/g,'').trim();
      target.searchParams.set('q',vehicleSearchQuery(q));target.searchParams.set('type','product');location.replace(target.href);return;
    }
  }
  if(location.pathname==='/search') {
    document.querySelectorAll('input[name="q"]').forEach(input=>{input.value=plainSearchQuery(input.value);});
  }
  // Quote literal shopper terms so combining them with a vehicle tag narrows the query.
  function plainSearchQuery(query) {
    return query.replace(/(?:\s*AND\s*)?tag:fh-vehicle-[a-z0-9-]+/g,'').trim()
      .replace(/"\s+AND\s+"/g,' ').replace(/^"|"$/g,'').replace(/\\"/g,'"');
  }
  function vehicleSearchQuery(query) {
    const words=plainSearchQuery(query).split(/\s+/).filter(Boolean).map(word=>JSON.stringify(word));
    return [...words,'tag:fh-vehicle-'+vehicle.key].join(' AND ');
  }
  const dialog = document.querySelector('#fh-vehicle-dialog');
  const cleanPath = path => path.replace(/\/fh-vehicle-[^/]+$/, '');
  const matchesVehicle = entry => !!(entry && vehicle && entry.vehicles.includes(vehicle.key) && (!vehicle.year || !entry.years || (+vehicle.year>=entry.years[0] && +vehicle.year<=entry.years[1])));
  function collectionPath(path) {return vehicle ? cleanPath(path)+'/fh-vehicle-'+vehicle.key : cleanPath(path);}
  let returnFocus;
  function choices(container,name,list,selected) {
    container.replaceChildren(...list.map(([label,value])=>{
      const tile=document.createElement('label'),radio=document.createElement('input'),text=document.createElement('span');
      radio.type='radio';radio.name=name;radio.value=value;radio.required=true;radio.checked=String(value)===String(selected);text.textContent=label;tile.append(radio,text);return tile;
    }));
  }
  function yearOptions(form,selected) {
    const model=form.elements.model.value,ranges=Object.values(catalog).filter(x=>x.vehicles.includes(model)&&x.years).map(x=>x.years);
    const years=[];for(let y=2020;y<=new Date().getFullYear();y++)if(ranges.some(r=>y>=r[0]&&y<=r[1]))years.push([String(y),String(y)]);
    years.push(['Not sure','unknown']);choices(form.querySelector('[data-fh-years]'),'year',years,selected);
    const modelLabel=(models[form.elements.make.value]||[]).find(m=>m[1]===model)?.[0]||'vehicle';
    form.querySelector('[data-fh-vehicle-submit]').textContent='Show accessories for my '+modelLabel;
  }
  function modelOptions(form,selected,year) {
    const list=models[form.elements.make.value]||[];
    choices(form.querySelector('[data-fh-models]'),'model',list,selected||list[0]?.[1]);yearOptions(form,year);
  }
  function updateVehicleUI() {
    const label=vehicle?[vehicle.year,vehicle.make,vehicle.model].filter(Boolean).join(' '):'Which vehicle do you drive?';
    document.querySelectorAll('[data-fh-vehicle-label]').forEach(x=>x.textContent=label);
    document.querySelectorAll('.fh-vehiclebar').forEach(x=>x.classList.toggle('is-saved',!!vehicle));
    document.querySelectorAll('[data-fh-vehicle-action]').forEach(x=>x.textContent=vehicle?'Change':'Select my vehicle');
    document.querySelectorAll('[data-fh-vehicle-clear]').forEach(x=>x.hidden=!vehicle);
    document.querySelectorAll('[data-fh-vehicle-form]').forEach(form=>{
      if(vehicle)form.elements.make.value=vehicle.make;
      modelOptions(form,vehicle?.key,vehicle?vehicle.year||'unknown':undefined);
    });filterCards();
  }
  document.querySelectorAll('[data-fh-vehicle-form]').forEach(form=>{
    form.addEventListener('change',event=>{if(event.target.name==='make')modelOptions(form);if(event.target.name==='model')yearOptions(form);});
    form.addEventListener('submit',event=>{
      event.preventDefault();if(!form.reportValidity())return;
      const m=(models[form.elements.make.value] || []).find(x=>x[1]===form.elements.model.value);if(!m)return;
      vehicle={year:form.elements.year.value==='unknown'?null:form.elements.year.value,make:form.elements.make.value,model:m[0],key:m[1]};
      try{localStorage.setItem(key,JSON.stringify(vehicle));}catch(_){}
      dialog?.close();updateVehicleUI();
      if(location.pathname.startsWith('/products/')) {updateProductVehicle();return;}
      const dest=location.pathname.startsWith('/collections/') ? collectionPath(location.pathname) : '/collections/'+(vehicle.key==='byd-shark-6'?'byd-shark-6-accessories':vehicle.key.startsWith('gwm-cannon')?'gwm-cannon-accessories':'denza-accessories')+'/fh-vehicle-'+vehicle.key;
      const destination=new URL(dest,location.origin);destination.search=location.search;destination.searchParams.delete('page');location.assign(destination.href);
    });
  });
  document.querySelectorAll('[data-fh-vehicle-open]').forEach(x=>x.addEventListener('click',()=>{returnFocus=x;dialog?.showModal();dialog?.querySelector('[data-fh-vehicle-close]')?.focus();}));
  dialog?.addEventListener('close',()=>returnFocus?.focus());
  dialog?.addEventListener('keydown',event=>{
    if(event.key!=='Tab')return;
    const items=[...dialog.querySelectorAll('button,input,select,a[href],[tabindex]')].filter(x=>!x.disabled&&x.tabIndex>=0&&x.getClientRects().length);
    const first=items[0],last=items.at(-1);
    if(event.shiftKey&&document.activeElement===first){event.preventDefault();last?.focus();}
    else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first?.focus();}
  });
  document.querySelectorAll('[data-fh-vehicle-close]').forEach(x=>x.addEventListener('click',()=>dialog?.close()));
  function clearVehicle(){
    vehicle=null;try{localStorage.removeItem(key);}catch(_){}dialog?.close();updateVehicleUI();updateProductVehicle();
    const url=new URL(location.href);url.pathname=cleanPath(url.pathname);url.searchParams.delete('page');
    if(url.pathname==='/search')url.searchParams.set('q',plainSearchQuery(url.searchParams.get('q')||''));
    if(url.href!==location.href)location.assign(url.href);
  }
  document.querySelectorAll('[data-fh-vehicle-clear]').forEach(x=>x.addEventListener('click',clearVehicle));
  document.addEventListener('click',event=>{
    const anchor=event.target.closest('a[href]');if(!anchor||event.ctrlKey||event.metaKey||event.shiftKey||event.button!==0)return;
    const url=new URL(anchor.href,location.href);
    if(vehicle && url.origin===location.origin && /^\/collections\/[^/]+(?:\/fh-vehicle-[^/]+)?$/.test(url.pathname)) {
      url.pathname=collectionPath(url.pathname);anchor.href=url.href;
    }
  },true);
  document.addEventListener('submit',event=>{
    const form=event.target;
    if(vehicle && form instanceof HTMLFormElement && /\/search$/.test(new URL(form.action,location.href).pathname)) {
      const q=form.elements.namedItem('q');if(!q)return;
      q.value=vehicleSearchQuery(q.value);
    }
  },true);
  function filterCards() {
    const summary=document.querySelector('[data-fh-collection-vehicle]'),banner=document.querySelector('[data-fh-collection-filter]');
    if(summary){summary.hidden=!vehicle;summary.textContent=vehicle?'Showing items listed for your '+[vehicle.year,vehicle.make,vehicle.model].filter(Boolean).join(' ')+'.':'';}
    if(banner){banner.hidden=!vehicle;if(vehicle){const text=document.createElement('span'),clear=document.createElement('button');text.textContent='Showing mapped listings for your vehicle. Clear to browse all products. ';clear.type='button';clear.textContent='Clear vehicle';clear.addEventListener('click',clearVehicle);banner.replaceChildren(text,clear);}}

    document.querySelectorAll('[data-fh-card]').forEach(card=>{
      const entry=catalog[card.dataset.fhHandle];
      const matches=matchesVehicle(entry);
      const holder=card.closest('.product-grid__item') || card.closest('.predictive-search-results__card') || card.closest('slideshow-slide') || card;
      holder.classList.toggle('fh-hidden-card',!!vehicle&&!matches);
      const fit=card.querySelector('[data-fh-fit]');
      if(fit)fit.textContent=vehicle&&matches?`${vehicle.make} ${vehicle.model}`:entry?.vehicles.length?'Vehicle listing':'Choose a vehicle';
    });
    document.querySelectorAll('.product-grid, .fh-rec-grid').forEach(grid=>{
      let note=grid.parentElement.querySelector(':scope > .fh-filter-note');
      if(vehicle && !banner && !note){note=document.createElement('p');note.className='fh-filter-note';grid.before(note);}
      if(note){note.hidden=!vehicle;if(vehicle)note.textContent=`Browsing ${vehicle.make} ${vehicle.model} listings. Other vehicles and unmapped products are hidden. Clear your vehicle to browse everything.`;}
      const cards=[...grid.querySelectorAll('[data-fh-card]')];
      let empty=grid.parentElement.querySelector(':scope > .fh-filter-empty');
      const none=vehicle && cards.length>0 && cards.every(c=>c.closest('.fh-hidden-card'));
      if(none&&!empty){empty=document.createElement('p');empty.className='fh-filter-empty fh-filter-note';empty.textContent='No mapped listings in this selection. Try the vehicle range or clear your vehicle above.';grid.after(empty);}
      if(empty)empty.hidden=!none;
    });
  }
  let scheduled=false;
  new MutationObserver(mutations=>{
    if(scheduled||!mutations.some(m=>[...m.addedNodes].some(n=>n.nodeType===1 && (n.matches?.('[data-fh-card]')||n.querySelector?.('[data-fh-card]')))))return;
    scheduled=true;requestAnimationFrame(()=>{scheduled=false;filterCards();});
  }).observe(document.body,{childList:true,subtree:true});
  const product=document.querySelector('[data-fh-product]');
  let data,chosen;
  function updateProductVehicle(){
    if(!product||!data)return;
    let warning=product.querySelector('[data-fh-mismatch]');
    if(!warning){warning=document.createElement('p');warning.dataset.fhMismatch='';warning.className='fh-stock-warning';product.querySelector('h1').after(warning);}
    const mismatch=vehicle&&!matchesVehicle(catalog[data.handle]);
    warning.hidden=!mismatch;
    const entry=catalog[data.handle];
    const reason=!entry?.vehicles.length?'This product has no confirmed vehicle mapping. Check compatibility before ordering.':entry?.vehicles.includes(vehicle?.key)?`This listing covers ${entry.years?.[0]} to ${entry.years?.[1]}.`:'This listing is for another model.';
    warning.textContent=mismatch?`Your saved vehicle is ${vehicle.year?vehicle.year+' ':''}${vehicle.make} ${vehicle.model}. ${reason} Change or clear your vehicle before choosing.`:'';
  }
  if(product){
    data=JSON.parse(product.querySelector('[data-fh-product-data]').textContent);
    const form=product.querySelector('#fh-product-form'),state=product.querySelector('[data-fh-state]');
    function update(){
      chosen=data.variants.find(v=>String(v.id)===String(form.elements.id.value))||data.variants[0];
      const installed=/installation/i.test(chosen.title);
      const rates=data.freight[String(chosen.id)] || {};
      const freight=rates[installed?'QLD':state.value];
      const hasRate=Number.isFinite(freight);
      const total=chosen.price+(hasRate?freight:0);
      product.querySelector('[data-fh-freight]').hidden=installed;
      product.querySelector('[data-fh-install]').hidden=!installed;
      product.querySelector('[data-fh-install]').textContent=hasRate?`Workshop delivery: ${money(freight)} estimate for one item`:'Workshop delivery rate needs confirmation.';
      product.querySelector('[data-fh-freight-line]').textContent=hasRate?`Delivery to ${state.value}: ${money(freight)} estimate for one item`:'Delivery rate needs confirmation for this selection.';
      product.querySelector('[data-fh-total]').textContent=installed?`${money(total)} fitted package ${hasRate?'including workshop delivery':'plus delivery to confirm'}`:`${money(total)} ${hasRate?'indicative delivered total':'plus delivery to confirm'}`;
      const cart=product.querySelector('[data-fh-add]');cart.disabled=!chosen.available;
      cart.textContent=chosen.available?`Add to cart · ${money(total)}${hasRate?(installed?' incl. delivery':' delivered'):' + delivery'}`:'Unavailable · ask about arrival';
      product.querySelector('[data-fh-cta-note]').textContent=installed?`${money(chosen.price)} fitted package${hasRate?' + workshop delivery '+money(freight):' + delivery to confirm'}. We call you to book.`:`${money(chosen.price)} product${hasRate?' + '+state.value+' delivery '+money(freight):' + delivery to confirm'}. Nothing is charged at this step.`;
      const stock=chosen.available?'Need it by a date?':'Ask us about the next arrival.';
      product.querySelector('[data-fh-stock]').textContent=stock;
      const availability=data.handle==='byd-shark-6-electric-cargoguard-v3-pro-roller-shutter'
        ? 'Supplier stock must be checked for this item.'
        : 'Supplier availability is not a physical stock count.';
      product.querySelector('[data-fh-stock-detail]').textContent=availability;
      const included=product.querySelector('[data-fh-included]');if(included)included.textContent=`${money(total)} including ${state.value} delivery`;
      const balance=product.querySelector('[data-fh-balance]');if(balance)balance.textContent=`Illustrative reserve: A$100. Remaining ${installed?'installed':'delivered'} balance: ${money(Math.max(0,total-10000))}.`;
      const url=new URL(location.href);url.searchParams.set('variant',chosen.id);history.replaceState(null,'',url);
    }
    form.addEventListener('change',update);state.addEventListener('change',update);
    form.addEventListener('submit',event=>{if(!chosen.available){event.preventDefault();return;}const url=new URL(location.href);const preview=url.searchParams.get('preview_theme_id');if(preview)form.elements.return_to.value='/cart?preview_theme_id='+encodeURIComponent(preview);});
    product.querySelectorAll('[data-fh-image]').forEach(button=>button.addEventListener('click',()=>{const photo=product.querySelector('[data-fh-main-photo]');photo.removeAttribute('srcset');photo.src=button.dataset.fhImage;photo.alt=button.dataset.fhImageAlt;product.querySelectorAll('[data-fh-image]').forEach(x=>x.setAttribute('aria-pressed',String(x===button)));}));
    product.querySelector('[data-fh-gallery-more]')?.addEventListener('click',event=>{product.querySelectorAll('[data-fh-extra-photo]').forEach(x=>x.hidden=false);event.currentTarget.hidden=true;product.querySelector('[data-fh-extra-photo]')?.focus();});
    product.querySelector('[data-fh-state-toggle]')?.addEventListener('click',event=>{const field=product.querySelector('#fh-state-control');field.hidden=!field.hidden;event.currentTarget.setAttribute('aria-expanded',String(!field.hidden));if(!field.hidden)state.focus();});
    product.querySelector('[data-fh-freight-line]').title='Estimate for one item from the current store rates. Actual carrier costs and remote-area rules need confirmation. Multi-item delivery is calculated at checkout.';
    product.querySelectorAll('[data-fh-open-detail]').forEach(link=>link.addEventListener('click',()=>{document.getElementById(link.dataset.fhOpenDetail).open=true;}));
    product.querySelector('[data-fh-reserve]')?.addEventListener('click',()=>{const out=product.querySelector('[data-fh-reserve-output]');out.hidden=!out.hidden;});
    update();updateProductVehicle();
  }
  updateVehicleUI();
})();

/* Background video: motion preference respected; playback stays user-controllable. */
(() => {
 const video=document.querySelector('[data-fh-hero-video]'),button=document.querySelector('[data-fh-video-toggle]');
 if(!video||!button)return;
 const motion=window.matchMedia('(prefers-reduced-motion: reduce)');
 const sync=()=>{button.textContent=video.paused?'Play video':'Pause video';button.setAttribute('aria-label',(video.paused?'Play':'Pause')+' background video');};
 const play=()=>{video.querySelectorAll('source[data-src]').forEach(s=>{if(!s.src)s.src=s.dataset.src;});if(video.readyState===0)video.load();video.play().catch(sync);};
 button.hidden=false;button.addEventListener('click',()=>video.paused?play():video.pause());
 video.addEventListener('play',sync);video.addEventListener('pause',sync);motion.addEventListener('change',()=>{if(motion.matches)video.pause();});
 if(!motion.matches)play();sync();
})();
